(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jjFgX", function(module, exports) {

$parcel$export(module.exports, "focus", function () { return src_default; });
$parcel$export(module.exports, "default", function () { return module_default; });
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (nodeIsAttached) return !node.getClientRects().length;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false;
        }
        return true;
    });
    return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus");
        if (node === false) return false;
        if (node === void 0) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return void 0;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus2(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    };
    var checkTab = function checkTab2(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (e.shiftKey) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        }
    };
    var checkKey = function checkKey2(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return;
        activeFocusTraps.activateTrap(trap);
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation2() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    };
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        let undoInert = ()=>{};
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        if (modifiers.includes("inert")) options.onPostActivate = ()=>{
            Alpine.nextTick(()=>{
                undoInert = setInert(el);
            });
        };
        let trap = createFocusTrap(el, options);
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/ 
});

/**
 * Import polyfills
 */ window.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
/**
 * Custom scrollBy that handles Safari's issues with scrollBy and scroll snapping
 * @param {ScrollToOptions} options - The scroll options (left, top, behavior)
 */ HTMLElement.prototype._scrollBy = function(options) {
    if (!window.isSafari) {
        this.scrollBy(options);
        return;
    }
    // Safari has issues with scrollBy and scroll snapping
    // Use scrollTo with calculated position instead
    this.scrollTo({
        left: this.scrollLeft + (options.left || 0),
        top: this.scrollTop + (options.top || 0),
        behavior: options.behavior || 'smooth'
    });
};


/**
 * @description Shopify functions
 */ /**
 * @description Helper functions
 */ /**
 * Utility function to create a delay.
 *
 * @param timeout - The number of milliseconds to wait.
 * @returns A promise that resolves after the specified delay.
 */ function $77eae7726dbdfc03$export$5c069c93d2b7493f(timeout = 0) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $77eae7726dbdfc03$export$1a1c301579a08d1e(selector) {
    return new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            if (element = document.querySelector(selector)) {
                clearInterval(interval);
                resolve(element);
            }
        }, 100);
    });
}
function $77eae7726dbdfc03$export$b28d0a0c2ceb8a25(amount = 0) {
    return new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}` || "en-GB", {
        style: "currency",
        currency: Shopify.currency.active || "GBP"
    }).format(amount);
}
function $77eae7726dbdfc03$export$625550452a3fa3ec(key, variables = {}) {
    const translations = window.themeTranslations || {};
    let message = translations[key] || key;
    Object.entries(variables).forEach(([name, value])=>{
        const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = new RegExp(`\\{\\{\\s*${escapedName}\\s*\\}\\}`, "g");
        message = message.replace(pattern, value);
    });
    return message;
}
function $77eae7726dbdfc03$export$7bf6fd20e75fd96(array, key) {
    const seen = new Set();
    return array.filter((item)=>{
        const value = key ? item[key] : JSON.stringify(item);
        if (seen.has(value)) return false;
        seen.add(value);
        return true;
    });
}


// packages/alpinejs/src/scheduler.js
var $99b18dd98d1424fc$var$flushPending = false;
var $99b18dd98d1424fc$var$flushing = false;
var $99b18dd98d1424fc$var$queue = [];
var $99b18dd98d1424fc$var$lastFlushedIndex = -1;
function $99b18dd98d1424fc$var$scheduler(callback) {
    $99b18dd98d1424fc$var$queueJob(callback);
}
function $99b18dd98d1424fc$var$queueJob(job) {
    if (!$99b18dd98d1424fc$var$queue.includes(job)) $99b18dd98d1424fc$var$queue.push(job);
    $99b18dd98d1424fc$var$queueFlush();
}
function $99b18dd98d1424fc$var$dequeueJob(job) {
    let index = $99b18dd98d1424fc$var$queue.indexOf(job);
    if (index !== -1 && index > $99b18dd98d1424fc$var$lastFlushedIndex) $99b18dd98d1424fc$var$queue.splice(index, 1);
}
function $99b18dd98d1424fc$var$queueFlush() {
    if (!$99b18dd98d1424fc$var$flushing && !$99b18dd98d1424fc$var$flushPending) {
        $99b18dd98d1424fc$var$flushPending = true;
        queueMicrotask($99b18dd98d1424fc$var$flushJobs);
    }
}
function $99b18dd98d1424fc$var$flushJobs() {
    $99b18dd98d1424fc$var$flushPending = false;
    $99b18dd98d1424fc$var$flushing = true;
    for(let i = 0; i < $99b18dd98d1424fc$var$queue.length; i++){
        $99b18dd98d1424fc$var$queue[i]();
        $99b18dd98d1424fc$var$lastFlushedIndex = i;
    }
    $99b18dd98d1424fc$var$queue.length = 0;
    $99b18dd98d1424fc$var$lastFlushedIndex = -1;
    $99b18dd98d1424fc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $99b18dd98d1424fc$var$reactive;
var $99b18dd98d1424fc$var$effect;
var $99b18dd98d1424fc$var$release;
var $99b18dd98d1424fc$var$raw;
var $99b18dd98d1424fc$var$shouldSchedule = true;
function $99b18dd98d1424fc$var$disableEffectScheduling(callback) {
    $99b18dd98d1424fc$var$shouldSchedule = false;
    callback();
    $99b18dd98d1424fc$var$shouldSchedule = true;
}
function $99b18dd98d1424fc$var$setReactivityEngine(engine) {
    $99b18dd98d1424fc$var$reactive = engine.reactive;
    $99b18dd98d1424fc$var$release = engine.release;
    $99b18dd98d1424fc$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($99b18dd98d1424fc$var$shouldSchedule) $99b18dd98d1424fc$var$scheduler(task);
                else task();
            }
        });
    $99b18dd98d1424fc$var$raw = engine.raw;
}
function $99b18dd98d1424fc$var$overrideEffect(override) {
    $99b18dd98d1424fc$var$effect = override;
}
function $99b18dd98d1424fc$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $99b18dd98d1424fc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $99b18dd98d1424fc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $99b18dd98d1424fc$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $99b18dd98d1424fc$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$99b18dd98d1424fc$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $99b18dd98d1424fc$var$onAttributeAddeds = [];
var $99b18dd98d1424fc$var$onElRemoveds = [];
var $99b18dd98d1424fc$var$onElAddeds = [];
function $99b18dd98d1424fc$var$onElAdded(callback) {
    $99b18dd98d1424fc$var$onElAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $99b18dd98d1424fc$var$onElRemoveds.push(callback);
    }
}
function $99b18dd98d1424fc$var$onAttributesAdded(callback) {
    $99b18dd98d1424fc$var$onAttributeAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $99b18dd98d1424fc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $99b18dd98d1424fc$var$cleanupElement(el) {
    el._x_effects?.forEach($99b18dd98d1424fc$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $99b18dd98d1424fc$var$observer = new MutationObserver($99b18dd98d1424fc$var$onMutate);
var $99b18dd98d1424fc$var$currentlyObserving = false;
function $99b18dd98d1424fc$var$startObservingMutations() {
    $99b18dd98d1424fc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $99b18dd98d1424fc$var$currentlyObserving = true;
}
function $99b18dd98d1424fc$var$stopObservingMutations() {
    $99b18dd98d1424fc$var$flushObserver();
    $99b18dd98d1424fc$var$observer.disconnect();
    $99b18dd98d1424fc$var$currentlyObserving = false;
}
var $99b18dd98d1424fc$var$queuedMutations = [];
function $99b18dd98d1424fc$var$flushObserver() {
    let records = $99b18dd98d1424fc$var$observer.takeRecords();
    $99b18dd98d1424fc$var$queuedMutations.push(()=>records.length > 0 && $99b18dd98d1424fc$var$onMutate(records));
    let queueLengthWhenTriggered = $99b18dd98d1424fc$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($99b18dd98d1424fc$var$queuedMutations.length === queueLengthWhenTriggered) while($99b18dd98d1424fc$var$queuedMutations.length > 0)$99b18dd98d1424fc$var$queuedMutations.shift()();
    });
}
function $99b18dd98d1424fc$var$mutateDom(callback) {
    if (!$99b18dd98d1424fc$var$currentlyObserving) return callback();
    $99b18dd98d1424fc$var$stopObservingMutations();
    let result = callback();
    $99b18dd98d1424fc$var$startObservingMutations();
    return result;
}
var $99b18dd98d1424fc$var$isCollecting = false;
var $99b18dd98d1424fc$var$deferredMutations = [];
function $99b18dd98d1424fc$var$deferMutations() {
    $99b18dd98d1424fc$var$isCollecting = true;
}
function $99b18dd98d1424fc$var$flushAndStopDeferringMutations() {
    $99b18dd98d1424fc$var$isCollecting = false;
    $99b18dd98d1424fc$var$onMutate($99b18dd98d1424fc$var$deferredMutations);
    $99b18dd98d1424fc$var$deferredMutations = [];
}
function $99b18dd98d1424fc$var$onMutate(mutations) {
    if ($99b18dd98d1424fc$var$isCollecting) {
        $99b18dd98d1424fc$var$deferredMutations = $99b18dd98d1424fc$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $99b18dd98d1424fc$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $99b18dd98d1424fc$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $99b18dd98d1424fc$var$scope(node) {
    return $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$closestDataStack(node));
}
function $99b18dd98d1424fc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$99b18dd98d1424fc$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $99b18dd98d1424fc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $99b18dd98d1424fc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $99b18dd98d1424fc$var$closestDataStack(node.parentNode);
}
function $99b18dd98d1424fc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $99b18dd98d1424fc$var$mergeProxyTrap);
}
var $99b18dd98d1424fc$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $99b18dd98d1424fc$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $99b18dd98d1424fc$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $99b18dd98d1424fc$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $99b18dd98d1424fc$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$99b18dd98d1424fc$var$get(data2, path), (value)=>$99b18dd98d1424fc$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $99b18dd98d1424fc$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $99b18dd98d1424fc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $99b18dd98d1424fc$var$magics = {};
function $99b18dd98d1424fc$var$magic(name, callback) {
    $99b18dd98d1424fc$var$magics[name] = callback;
}
function $99b18dd98d1424fc$var$injectMagics(obj, el) {
    let memoizedUtilities = $99b18dd98d1424fc$var$getUtilities(el);
    Object.entries($99b18dd98d1424fc$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$getUtilities(el) {
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $99b18dd98d1424fc$var$interceptor,
        ...utilities
    };
    $99b18dd98d1424fc$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $99b18dd98d1424fc$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $99b18dd98d1424fc$var$handleError(e, el, expression);
    }
}
function $99b18dd98d1424fc$var$handleError(...args) {
    return $99b18dd98d1424fc$var$errorHandler(...args);
}
var $99b18dd98d1424fc$var$errorHandler = $99b18dd98d1424fc$var$normalErrorHandler;
function $99b18dd98d1424fc$var$setErrorHandler(handler4) {
    $99b18dd98d1424fc$var$errorHandler = handler4;
}
function $99b18dd98d1424fc$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = true;
function $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(callback) {
    let cache = $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions;
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $99b18dd98d1424fc$var$evaluate(el, expression, extras = {}) {
    let result;
    $99b18dd98d1424fc$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $99b18dd98d1424fc$var$evaluateLater(...args) {
    return $99b18dd98d1424fc$var$theEvaluatorFunction(...args);
}
var $99b18dd98d1424fc$var$theEvaluatorFunction = $99b18dd98d1424fc$var$normalEvaluator;
function $99b18dd98d1424fc$var$setEvaluator(newEvaluator) {
    $99b18dd98d1424fc$var$theEvaluatorFunction = newEvaluator;
}
var $99b18dd98d1424fc$var$theRawEvaluatorFunction;
function $99b18dd98d1424fc$var$setRawEvaluator(newEvaluator) {
    $99b18dd98d1424fc$var$theRawEvaluatorFunction = newEvaluator;
}
function $99b18dd98d1424fc$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $99b18dd98d1424fc$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$99b18dd98d1424fc$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, expression) : $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $99b18dd98d1424fc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$99b18dd98d1424fc$var$shouldAutoEvaluateFunctions) {
            $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, func, $99b18dd98d1424fc$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $99b18dd98d1424fc$var$evaluatorMemo = {};
function $99b18dd98d1424fc$var$generateFunctionFromString(expression, el) {
    if ($99b18dd98d1424fc$var$evaluatorMemo[expression]) return $99b18dd98d1424fc$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $99b18dd98d1424fc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $99b18dd98d1424fc$var$evaluatorMemo[expression] = func;
    return func;
}
function $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $99b18dd98d1424fc$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression));
            if (func.finished) {
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($99b18dd98d1424fc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $99b18dd98d1424fc$var$evaluateRaw(...args) {
    return $99b18dd98d1424fc$var$theRawEvaluatorFunction(...args);
}
function $99b18dd98d1424fc$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $99b18dd98d1424fc$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$99b18dd98d1424fc$var$closestDataStack(el)
    ];
    let scope2 = $99b18dd98d1424fc$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $99b18dd98d1424fc$var$prefixAsString = "x-";
function $99b18dd98d1424fc$var$prefix(subject = "") {
    return $99b18dd98d1424fc$var$prefixAsString + subject;
}
function $99b18dd98d1424fc$var$setPrefix(newPrefix) {
    $99b18dd98d1424fc$var$prefixAsString = newPrefix;
}
var $99b18dd98d1424fc$var$directiveHandlers = {};
function $99b18dd98d1424fc$var$directive(name, callback) {
    $99b18dd98d1424fc$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$99b18dd98d1424fc$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $99b18dd98d1424fc$var$directiveOrder.indexOf(directive2);
            $99b18dd98d1424fc$var$directiveOrder.splice(pos >= 0 ? pos : $99b18dd98d1424fc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $99b18dd98d1424fc$var$directiveExists(name) {
    return Object.keys($99b18dd98d1424fc$var$directiveHandlers).includes(name);
}
function $99b18dd98d1424fc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($99b18dd98d1424fc$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($99b18dd98d1424fc$var$outNonAlpineAttributes).map($99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($99b18dd98d1424fc$var$byPriority);
    return directives2.map((directive2)=>{
        return $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2);
    });
}
function $99b18dd98d1424fc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($99b18dd98d1424fc$var$toTransformedAttributes()).filter((attr)=>!$99b18dd98d1424fc$var$outNonAlpineAttributes(attr));
}
var $99b18dd98d1424fc$var$isDeferringHandlers = false;
var $99b18dd98d1424fc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $99b18dd98d1424fc$var$currentHandlerStackKey = Symbol();
function $99b18dd98d1424fc$var$deferHandlingDirectives(callback) {
    $99b18dd98d1424fc$var$isDeferringHandlers = true;
    let key = Symbol();
    $99b18dd98d1424fc$var$currentHandlerStackKey = key;
    $99b18dd98d1424fc$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($99b18dd98d1424fc$var$directiveHandlerStacks.get(key).length)$99b18dd98d1424fc$var$directiveHandlerStacks.get(key).shift()();
        $99b18dd98d1424fc$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $99b18dd98d1424fc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $99b18dd98d1424fc$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $99b18dd98d1424fc$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $99b18dd98d1424fc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $99b18dd98d1424fc$var$evaluateLater.bind($99b18dd98d1424fc$var$evaluateLater, el),
        evaluate: $99b18dd98d1424fc$var$evaluate.bind($99b18dd98d1424fc$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $99b18dd98d1424fc$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    $99b18dd98d1424fc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $99b18dd98d1424fc$var$isDeferringHandlers ? $99b18dd98d1424fc$var$directiveHandlerStacks.get($99b18dd98d1424fc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $99b18dd98d1424fc$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $99b18dd98d1424fc$var$into = (i)=>i;
function $99b18dd98d1424fc$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $99b18dd98d1424fc$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $99b18dd98d1424fc$var$attributeTransformers = [];
function $99b18dd98d1424fc$var$mapAttributes(callback) {
    $99b18dd98d1424fc$var$attributeTransformers.push(callback);
}
function $99b18dd98d1424fc$var$outNonAlpineAttributes({ name: name }) {
    return $99b18dd98d1424fc$var$alpineAttributeRegex().test(name);
}
var $99b18dd98d1424fc$var$alpineAttributeRegex = ()=>new RegExp(`^${$99b18dd98d1424fc$var$prefixAsString}([^:^.]+)\\b`);
function $99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($99b18dd98d1424fc$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $99b18dd98d1424fc$var$DEFAULT = "DEFAULT";
var $99b18dd98d1424fc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $99b18dd98d1424fc$var$DEFAULT,
    "teleport"
];
function $99b18dd98d1424fc$var$byPriority(a, b) {
    let typeA = $99b18dd98d1424fc$var$directiveOrder.indexOf(a.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : a.type;
    let typeB = $99b18dd98d1424fc$var$directiveOrder.indexOf(b.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : b.type;
    return $99b18dd98d1424fc$var$directiveOrder.indexOf(typeA) - $99b18dd98d1424fc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $99b18dd98d1424fc$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $99b18dd98d1424fc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$99b18dd98d1424fc$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $99b18dd98d1424fc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $99b18dd98d1424fc$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $99b18dd98d1424fc$var$started = false;
function $99b18dd98d1424fc$var$start() {
    if ($99b18dd98d1424fc$var$started) $99b18dd98d1424fc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $99b18dd98d1424fc$var$started = true;
    if (!document.body) $99b18dd98d1424fc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:init");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initializing");
    $99b18dd98d1424fc$var$startObservingMutations();
    $99b18dd98d1424fc$var$onElAdded((el)=>$99b18dd98d1424fc$var$initTree(el, $99b18dd98d1424fc$var$walk));
    $99b18dd98d1424fc$var$onElRemoved((el)=>$99b18dd98d1424fc$var$destroyTree(el));
    $99b18dd98d1424fc$var$onAttributesAdded((el, attrs)=>{
        $99b18dd98d1424fc$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$99b18dd98d1424fc$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($99b18dd98d1424fc$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $99b18dd98d1424fc$var$initTree(el);
    });
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $99b18dd98d1424fc$var$warnAboutMissingPlugins();
    });
}
var $99b18dd98d1424fc$var$rootSelectorCallbacks = [];
var $99b18dd98d1424fc$var$initSelectorCallbacks = [];
function $99b18dd98d1424fc$var$rootSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $99b18dd98d1424fc$var$allSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.concat($99b18dd98d1424fc$var$initSelectorCallbacks).map((fn)=>fn());
}
function $99b18dd98d1424fc$var$addRootSelector(selectorCallback) {
    $99b18dd98d1424fc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$addInitSelector(selectorCallback) {
    $99b18dd98d1424fc$var$initSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$closestRoot(el, includeInitSelectors = false) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $99b18dd98d1424fc$var$allSelectors() : $99b18dd98d1424fc$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $99b18dd98d1424fc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $99b18dd98d1424fc$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $99b18dd98d1424fc$var$findClosest(el.parentElement, callback);
}
function $99b18dd98d1424fc$var$isRoot(el) {
    return $99b18dd98d1424fc$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $99b18dd98d1424fc$var$initInterceptors2 = [];
function $99b18dd98d1424fc$var$interceptInit(callback) {
    $99b18dd98d1424fc$var$initInterceptors2.push(callback);
}
var $99b18dd98d1424fc$var$markerDispenser = 1;
function $99b18dd98d1424fc$var$initTree(el, walker = $99b18dd98d1424fc$var$walk, intercept = ()=>{}) {
    if ($99b18dd98d1424fc$var$findClosest(el, (i)=>i._x_ignore)) return;
    $99b18dd98d1424fc$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $99b18dd98d1424fc$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $99b18dd98d1424fc$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $99b18dd98d1424fc$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $99b18dd98d1424fc$var$destroyTree(root, walker = $99b18dd98d1424fc$var$walk) {
    walker(root, (el)=>{
        $99b18dd98d1424fc$var$cleanupElement(el);
        $99b18dd98d1424fc$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $99b18dd98d1424fc$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($99b18dd98d1424fc$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $99b18dd98d1424fc$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $99b18dd98d1424fc$var$tickStack = [];
var $99b18dd98d1424fc$var$isHolding = false;
function $99b18dd98d1424fc$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $99b18dd98d1424fc$var$isHolding || setTimeout(()=>{
            $99b18dd98d1424fc$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $99b18dd98d1424fc$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $99b18dd98d1424fc$var$releaseNextTicks() {
    $99b18dd98d1424fc$var$isHolding = false;
    while($99b18dd98d1424fc$var$tickStack.length)$99b18dd98d1424fc$var$tickStack.shift()();
}
function $99b18dd98d1424fc$var$holdNextTicks() {
    $99b18dd98d1424fc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $99b18dd98d1424fc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $99b18dd98d1424fc$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $99b18dd98d1424fc$var$setClasses(el, value());
    return $99b18dd98d1424fc$var$setClassesFromString(el, value);
}
function $99b18dd98d1424fc$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $99b18dd98d1424fc$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $99b18dd98d1424fc$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setStylesFromObject(el, value);
    return $99b18dd98d1424fc$var$setStylesFromString(el, value);
}
function $99b18dd98d1424fc$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $99b18dd98d1424fc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $99b18dd98d1424fc$var$setStyles(el, previousStyles);
    };
}
function $99b18dd98d1424fc$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $99b18dd98d1424fc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $99b18dd98d1424fc$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$99b18dd98d1424fc$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, expression, value);
});
function $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, classString, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $99b18dd98d1424fc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $99b18dd98d1424fc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $99b18dd98d1424fc$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $99b18dd98d1424fc$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $99b18dd98d1424fc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $99b18dd98d1424fc$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $99b18dd98d1424fc$var$closestHide(parent);
}
function $99b18dd98d1424fc$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $99b18dd98d1424fc$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $99b18dd98d1424fc$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $99b18dd98d1424fc$var$once(()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $99b18dd98d1424fc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $99b18dd98d1424fc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $99b18dd98d1424fc$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $99b18dd98d1424fc$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                stages.end();
            });
            $99b18dd98d1424fc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $99b18dd98d1424fc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $99b18dd98d1424fc$var$isCloning = false;
function $99b18dd98d1424fc$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning ? fallback(...args) : callback(...args);
}
function $99b18dd98d1424fc$var$onlyDuringClone(callback) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning && callback(...args);
}
var $99b18dd98d1424fc$var$interceptors = [];
function $99b18dd98d1424fc$var$interceptClone(callback) {
    $99b18dd98d1424fc$var$interceptors.push(callback);
}
function $99b18dd98d1424fc$var$cloneNode(from, to) {
    $99b18dd98d1424fc$var$interceptors.forEach((i)=>i(from, to));
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $99b18dd98d1424fc$var$isCloning = false;
}
var $99b18dd98d1424fc$var$isCloningLegacy = false;
function $99b18dd98d1424fc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$isCloningLegacy = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$cloneTree(newEl);
    });
    $99b18dd98d1424fc$var$isCloning = false;
    $99b18dd98d1424fc$var$isCloningLegacy = false;
}
function $99b18dd98d1424fc$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $99b18dd98d1424fc$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $99b18dd98d1424fc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $99b18dd98d1424fc$var$initTree(el, shallowWalker);
}
function $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $99b18dd98d1424fc$var$effect;
    $99b18dd98d1424fc$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $99b18dd98d1424fc$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $99b18dd98d1424fc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $99b18dd98d1424fc$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $99b18dd98d1424fc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $99b18dd98d1424fc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $99b18dd98d1424fc$var$bindInputValue(el, value);
            break;
        case "style":
            $99b18dd98d1424fc$var$bindStyles(el, value);
            break;
        case "class":
            $99b18dd98d1424fc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $99b18dd98d1424fc$var$bindAttribute(el, name, value);
            break;
    }
}
function $99b18dd98d1424fc$var$bindInputValue(el, value) {
    if ($99b18dd98d1424fc$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $99b18dd98d1424fc$var$safeParseBoolean(el.value) === value;
            else el.checked = $99b18dd98d1424fc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$99b18dd98d1424fc$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $99b18dd98d1424fc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $99b18dd98d1424fc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $99b18dd98d1424fc$var$setClasses(el, value);
}
function $99b18dd98d1424fc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $99b18dd98d1424fc$var$setStyles(el, value);
}
function $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value) {
    $99b18dd98d1424fc$var$bindAttribute(el, name, value);
    $99b18dd98d1424fc$var$setPropertyIfChanged(el, name, value);
}
function $99b18dd98d1424fc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($99b18dd98d1424fc$var$isBooleanAttr(name)) value = name;
        $99b18dd98d1424fc$var$setIfChanged(el, name, value);
    }
}
function $99b18dd98d1424fc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $99b18dd98d1424fc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $99b18dd98d1424fc$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $99b18dd98d1424fc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $99b18dd98d1424fc$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $99b18dd98d1424fc$var$isBooleanAttr(attrName) {
    return $99b18dd98d1424fc$var$booleanAttributes.has(attrName);
}
function $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $99b18dd98d1424fc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(()=>{
            return $99b18dd98d1424fc$var$evaluate(el, binding.expression);
        });
    }
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($99b18dd98d1424fc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $99b18dd98d1424fc$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $99b18dd98d1424fc$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $99b18dd98d1424fc$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $99b18dd98d1424fc$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $99b18dd98d1424fc$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $99b18dd98d1424fc$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($99b18dd98d1424fc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $99b18dd98d1424fc$var$release(reference);
    };
}
function $99b18dd98d1424fc$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $99b18dd98d1424fc$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($99b18dd98d1424fc$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $99b18dd98d1424fc$var$stores = {};
var $99b18dd98d1424fc$var$isReactive = false;
function $99b18dd98d1424fc$var$store(name, value) {
    if (!$99b18dd98d1424fc$var$isReactive) {
        $99b18dd98d1424fc$var$stores = $99b18dd98d1424fc$var$reactive($99b18dd98d1424fc$var$stores);
        $99b18dd98d1424fc$var$isReactive = true;
    }
    if (value === void 0) return $99b18dd98d1424fc$var$stores[name];
    $99b18dd98d1424fc$var$stores[name] = value;
    $99b18dd98d1424fc$var$initInterceptors($99b18dd98d1424fc$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $99b18dd98d1424fc$var$stores[name].init();
}
function $99b18dd98d1424fc$var$getStores() {
    return $99b18dd98d1424fc$var$stores;
}
// packages/alpinejs/src/binds.js
var $99b18dd98d1424fc$var$binds = {};
function $99b18dd98d1424fc$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $99b18dd98d1424fc$var$applyBindingsObject(name, getBindings());
    else $99b18dd98d1424fc$var$binds[name] = getBindings;
    return ()=>{};
}
function $99b18dd98d1424fc$var$injectBindingProviders(obj) {
    Object.entries($99b18dd98d1424fc$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $99b18dd98d1424fc$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $99b18dd98d1424fc$var$datas = {};
function $99b18dd98d1424fc$var$data(name, callback) {
    $99b18dd98d1424fc$var$datas[name] = callback;
}
function $99b18dd98d1424fc$var$injectDataProviders(obj, context) {
    Object.entries($99b18dd98d1424fc$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $99b18dd98d1424fc$var$Alpine = {
    get reactive () {
        return $99b18dd98d1424fc$var$reactive;
    },
    get release () {
        return $99b18dd98d1424fc$var$release;
    },
    get effect () {
        return $99b18dd98d1424fc$var$effect;
    },
    get raw () {
        return $99b18dd98d1424fc$var$raw;
    },
    version: "3.15.3",
    flushAndStopDeferringMutations: $99b18dd98d1424fc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $99b18dd98d1424fc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $99b18dd98d1424fc$var$disableEffectScheduling,
    startObservingMutations: $99b18dd98d1424fc$var$startObservingMutations,
    stopObservingMutations: $99b18dd98d1424fc$var$stopObservingMutations,
    setReactivityEngine: $99b18dd98d1424fc$var$setReactivityEngine,
    onAttributeRemoved: $99b18dd98d1424fc$var$onAttributeRemoved,
    onAttributesAdded: $99b18dd98d1424fc$var$onAttributesAdded,
    closestDataStack: $99b18dd98d1424fc$var$closestDataStack,
    skipDuringClone: $99b18dd98d1424fc$var$skipDuringClone,
    onlyDuringClone: $99b18dd98d1424fc$var$onlyDuringClone,
    addRootSelector: $99b18dd98d1424fc$var$addRootSelector,
    addInitSelector: $99b18dd98d1424fc$var$addInitSelector,
    setErrorHandler: $99b18dd98d1424fc$var$setErrorHandler,
    interceptClone: $99b18dd98d1424fc$var$interceptClone,
    addScopeToNode: $99b18dd98d1424fc$var$addScopeToNode,
    deferMutations: $99b18dd98d1424fc$var$deferMutations,
    mapAttributes: $99b18dd98d1424fc$var$mapAttributes,
    evaluateLater: $99b18dd98d1424fc$var$evaluateLater,
    interceptInit: $99b18dd98d1424fc$var$interceptInit,
    initInterceptors: $99b18dd98d1424fc$var$initInterceptors,
    injectMagics: $99b18dd98d1424fc$var$injectMagics,
    setEvaluator: $99b18dd98d1424fc$var$setEvaluator,
    setRawEvaluator: $99b18dd98d1424fc$var$setRawEvaluator,
    mergeProxies: $99b18dd98d1424fc$var$mergeProxies,
    extractProp: $99b18dd98d1424fc$var$extractProp,
    findClosest: $99b18dd98d1424fc$var$findClosest,
    onElRemoved: $99b18dd98d1424fc$var$onElRemoved,
    closestRoot: $99b18dd98d1424fc$var$closestRoot,
    destroyTree: $99b18dd98d1424fc$var$destroyTree,
    interceptor: $99b18dd98d1424fc$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $99b18dd98d1424fc$var$transition,
    setStyles: // INTERNAL
    $99b18dd98d1424fc$var$setStyles,
    mutateDom: // INTERNAL
    $99b18dd98d1424fc$var$mutateDom,
    directive: $99b18dd98d1424fc$var$directive,
    entangle: $99b18dd98d1424fc$var$entangle,
    throttle: $99b18dd98d1424fc$var$throttle,
    debounce: $99b18dd98d1424fc$var$debounce,
    evaluate: $99b18dd98d1424fc$var$evaluate,
    evaluateRaw: $99b18dd98d1424fc$var$evaluateRaw,
    initTree: $99b18dd98d1424fc$var$initTree,
    nextTick: $99b18dd98d1424fc$var$nextTick,
    prefixed: $99b18dd98d1424fc$var$prefix,
    prefix: $99b18dd98d1424fc$var$setPrefix,
    plugin: $99b18dd98d1424fc$var$plugin,
    magic: $99b18dd98d1424fc$var$magic,
    store: $99b18dd98d1424fc$var$store,
    start: $99b18dd98d1424fc$var$start,
    clone: $99b18dd98d1424fc$var$clone,
    cloneNode: // INTERNAL
    $99b18dd98d1424fc$var$cloneNode,
    // INTERNAL
    bound: $99b18dd98d1424fc$var$getBinding,
    $data: $99b18dd98d1424fc$var$scope,
    watch: $99b18dd98d1424fc$var$watch,
    walk: $99b18dd98d1424fc$var$walk,
    data: $99b18dd98d1424fc$var$data,
    bind: $99b18dd98d1424fc$var$bind2
};
var $99b18dd98d1424fc$var$alpine_default = $99b18dd98d1424fc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $99b18dd98d1424fc$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $99b18dd98d1424fc$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $99b18dd98d1424fc$var$isBooleanAttr2 = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap($99b18dd98d1424fc$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $99b18dd98d1424fc$var$EMPTY_OBJ = Object.freeze({});
var $99b18dd98d1424fc$var$EMPTY_ARR = Object.freeze([]);
var $99b18dd98d1424fc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $99b18dd98d1424fc$var$hasOwn = (val, key)=>$99b18dd98d1424fc$var$hasOwnProperty.call(val, key);
var $99b18dd98d1424fc$var$isArray = Array.isArray;
var $99b18dd98d1424fc$var$isMap = (val)=>$99b18dd98d1424fc$var$toTypeString(val) === "[object Map]";
var $99b18dd98d1424fc$var$isString = (val)=>typeof val === "string";
var $99b18dd98d1424fc$var$isSymbol = (val)=>typeof val === "symbol";
var $99b18dd98d1424fc$var$isObject = (val)=>val !== null && typeof val === "object";
var $99b18dd98d1424fc$var$objectToString = Object.prototype.toString;
var $99b18dd98d1424fc$var$toTypeString = (value)=>$99b18dd98d1424fc$var$objectToString.call(value);
var $99b18dd98d1424fc$var$toRawType = (value)=>{
    return $99b18dd98d1424fc$var$toTypeString(value).slice(8, -1);
};
var $99b18dd98d1424fc$var$isIntegerKey = (key)=>$99b18dd98d1424fc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $99b18dd98d1424fc$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $99b18dd98d1424fc$var$camelizeRE = /-(\w)/g;
var $99b18dd98d1424fc$var$camelize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>{
    return str.replace($99b18dd98d1424fc$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $99b18dd98d1424fc$var$hyphenateRE = /\B([A-Z])/g;
var $99b18dd98d1424fc$var$hyphenate = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.replace($99b18dd98d1424fc$var$hyphenateRE, "-$1").toLowerCase());
var $99b18dd98d1424fc$var$capitalize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $99b18dd98d1424fc$var$toHandlerKey = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str ? `on${$99b18dd98d1424fc$var$capitalize(str)}` : ``);
var $99b18dd98d1424fc$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $99b18dd98d1424fc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$effectStack = [];
var $99b18dd98d1424fc$var$activeEffect;
var $99b18dd98d1424fc$var$ITERATE_KEY = Symbol("iterate");
var $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $99b18dd98d1424fc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $99b18dd98d1424fc$var$effect2(fn, options = $99b18dd98d1424fc$var$EMPTY_OBJ) {
    if ($99b18dd98d1424fc$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $99b18dd98d1424fc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $99b18dd98d1424fc$var$stop(effect3) {
    if (effect3.active) {
        $99b18dd98d1424fc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $99b18dd98d1424fc$var$uid = 0;
function $99b18dd98d1424fc$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$99b18dd98d1424fc$var$effectStack.includes(effect3)) {
            $99b18dd98d1424fc$var$cleanup(effect3);
            try {
                $99b18dd98d1424fc$var$enableTracking();
                $99b18dd98d1424fc$var$effectStack.push(effect3);
                $99b18dd98d1424fc$var$activeEffect = effect3;
                return fn();
            } finally{
                $99b18dd98d1424fc$var$effectStack.pop();
                $99b18dd98d1424fc$var$resetTracking();
                $99b18dd98d1424fc$var$activeEffect = $99b18dd98d1424fc$var$effectStack[$99b18dd98d1424fc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $99b18dd98d1424fc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $99b18dd98d1424fc$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $99b18dd98d1424fc$var$shouldTrack = true;
var $99b18dd98d1424fc$var$trackStack = [];
function $99b18dd98d1424fc$var$pauseTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = false;
}
function $99b18dd98d1424fc$var$enableTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = true;
}
function $99b18dd98d1424fc$var$resetTracking() {
    const last = $99b18dd98d1424fc$var$trackStack.pop();
    $99b18dd98d1424fc$var$shouldTrack = last === void 0 ? true : last;
}
function $99b18dd98d1424fc$var$track(target, type, key) {
    if (!$99b18dd98d1424fc$var$shouldTrack || $99b18dd98d1424fc$var$activeEffect === void 0) return;
    let depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) $99b18dd98d1424fc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($99b18dd98d1424fc$var$activeEffect)) {
        dep.add($99b18dd98d1424fc$var$activeEffect);
        $99b18dd98d1424fc$var$activeEffect.deps.push(dep);
        if ($99b18dd98d1424fc$var$activeEffect.options.onTrack) $99b18dd98d1424fc$var$activeEffect.options.onTrack({
            effect: $99b18dd98d1424fc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $99b18dd98d1424fc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $99b18dd98d1424fc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $99b18dd98d1424fc$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                } else if ($99b18dd98d1424fc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $99b18dd98d1424fc$var$isNonTrackableKeys = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $99b18dd98d1424fc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($99b18dd98d1424fc$var$isSymbol));
var $99b18dd98d1424fc$var$get2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter();
var $99b18dd98d1424fc$var$readonlyGet = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter(true);
var $99b18dd98d1424fc$var$arrayInstrumentations = /* @__PURE__ */ $99b18dd98d1424fc$var$createArrayInstrumentations();
function $99b18dd98d1424fc$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $99b18dd98d1424fc$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$99b18dd98d1424fc$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($99b18dd98d1424fc$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $99b18dd98d1424fc$var$pauseTracking();
            const res = $99b18dd98d1424fc$var$toRaw(this)[key].apply(this, args);
            $99b18dd98d1424fc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $99b18dd98d1424fc$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $99b18dd98d1424fc$var$shallowReadonlyMap : $99b18dd98d1424fc$var$readonlyMap : shallow ? $99b18dd98d1424fc$var$shallowReactiveMap : $99b18dd98d1424fc$var$reactiveMap).get(target)) return target;
        const targetIsArray = $99b18dd98d1424fc$var$isArray(target);
        if (!isReadonly && targetIsArray && $99b18dd98d1424fc$var$hasOwn($99b18dd98d1424fc$var$arrayInstrumentations, key)) return Reflect.get($99b18dd98d1424fc$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($99b18dd98d1424fc$var$isSymbol(key) ? $99b18dd98d1424fc$var$builtInSymbols.has(key) : $99b18dd98d1424fc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $99b18dd98d1424fc$var$track(target, "get", key);
        if (shallow) return res;
        if ($99b18dd98d1424fc$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$99b18dd98d1424fc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($99b18dd98d1424fc$var$isObject(res)) return isReadonly ? $99b18dd98d1424fc$var$readonly(res) : $99b18dd98d1424fc$var$reactive2(res);
        return res;
    };
}
var $99b18dd98d1424fc$var$set2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createSetter();
function $99b18dd98d1424fc$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $99b18dd98d1424fc$var$toRaw(value);
            oldValue = $99b18dd98d1424fc$var$toRaw(oldValue);
            if (!$99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isRef(oldValue) && !$99b18dd98d1424fc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isIntegerKey(key) ? Number(key) < target.length : $99b18dd98d1424fc$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $99b18dd98d1424fc$var$toRaw(receiver)) {
            if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
            else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $99b18dd98d1424fc$var$deleteProperty(target, key) {
    const hadKey = $99b18dd98d1424fc$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$99b18dd98d1424fc$var$isSymbol(key) || !$99b18dd98d1424fc$var$builtInSymbols.has(key)) $99b18dd98d1424fc$var$track(target, "has", key);
    return result;
}
function $99b18dd98d1424fc$var$ownKeys(target) {
    $99b18dd98d1424fc$var$track(target, "iterate", $99b18dd98d1424fc$var$isArray(target) ? "length" : $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $99b18dd98d1424fc$var$mutableHandlers = {
    get: $99b18dd98d1424fc$var$get2,
    set: $99b18dd98d1424fc$var$set2,
    deleteProperty: $99b18dd98d1424fc$var$deleteProperty,
    has: $99b18dd98d1424fc$var$has,
    ownKeys: $99b18dd98d1424fc$var$ownKeys
};
var $99b18dd98d1424fc$var$readonlyHandlers = {
    get: $99b18dd98d1424fc$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $99b18dd98d1424fc$var$toReactive = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$reactive2(value) : value;
var $99b18dd98d1424fc$var$toReadonly = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$readonly(value) : value;
var $99b18dd98d1424fc$var$toShallow = (value)=>value;
var $99b18dd98d1424fc$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $99b18dd98d1424fc$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $99b18dd98d1424fc$var$getProto(rawTarget);
    const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $99b18dd98d1424fc$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $99b18dd98d1424fc$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $99b18dd98d1424fc$var$track($99b18dd98d1424fc$var$toRaw(target), "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $99b18dd98d1424fc$var$add(value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const proto = $99b18dd98d1424fc$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $99b18dd98d1424fc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $99b18dd98d1424fc$var$set$1(key, value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
    else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $99b18dd98d1424fc$var$deleteEntry(key) {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$clear() {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $99b18dd98d1424fc$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $99b18dd98d1424fc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $99b18dd98d1424fc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $99b18dd98d1424fc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const targetIsMap = $99b18dd98d1424fc$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", isKeyOnly ? $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY : $99b18dd98d1424fc$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $99b18dd98d1424fc$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$99b18dd98d1424fc$var$capitalize(type)} operation ${key}failed: target is readonly.`, $99b18dd98d1424fc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $99b18dd98d1424fc$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, false, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$99b18dd98d1424fc$var$mutableInstrumentations, $99b18dd98d1424fc$var$readonlyInstrumentations, $99b18dd98d1424fc$var$shallowInstrumentations, $99b18dd98d1424fc$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentations();
function $99b18dd98d1424fc$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $99b18dd98d1424fc$var$shallowReadonlyInstrumentations : $99b18dd98d1424fc$var$shallowInstrumentations : isReadonly ? $99b18dd98d1424fc$var$readonlyInstrumentations : $99b18dd98d1424fc$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($99b18dd98d1424fc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $99b18dd98d1424fc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(false, false)
};
var $99b18dd98d1424fc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(true, false)
};
function $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $99b18dd98d1424fc$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $99b18dd98d1424fc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $99b18dd98d1424fc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $99b18dd98d1424fc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $99b18dd98d1424fc$var$targetTypeMap($99b18dd98d1424fc$var$toRawType(value));
}
function $99b18dd98d1424fc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $99b18dd98d1424fc$var$createReactiveObject(target, false, $99b18dd98d1424fc$var$mutableHandlers, $99b18dd98d1424fc$var$mutableCollectionHandlers, $99b18dd98d1424fc$var$reactiveMap);
}
function $99b18dd98d1424fc$var$readonly(target) {
    return $99b18dd98d1424fc$var$createReactiveObject(target, true, $99b18dd98d1424fc$var$readonlyHandlers, $99b18dd98d1424fc$var$readonlyCollectionHandlers, $99b18dd98d1424fc$var$readonlyMap);
}
function $99b18dd98d1424fc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$99b18dd98d1424fc$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $99b18dd98d1424fc$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $99b18dd98d1424fc$var$toRaw(observed) {
    return observed && $99b18dd98d1424fc$var$toRaw(observed["__v_raw"]) || observed;
}
function $99b18dd98d1424fc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$99b18dd98d1424fc$var$magic("nextTick", ()=>$99b18dd98d1424fc$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$99b18dd98d1424fc$var$magic("dispatch", (el)=>$99b18dd98d1424fc$var$dispatch.bind($99b18dd98d1424fc$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$99b18dd98d1424fc$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $99b18dd98d1424fc$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$99b18dd98d1424fc$var$magic("store", $99b18dd98d1424fc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$99b18dd98d1424fc$var$magic("data", (el)=>$99b18dd98d1424fc$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$99b18dd98d1424fc$var$magic("root", (el)=>$99b18dd98d1424fc$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$99b18dd98d1424fc$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $99b18dd98d1424fc$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $99b18dd98d1424fc$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $99b18dd98d1424fc$var$globalIdMemo = {};
function $99b18dd98d1424fc$var$findAndIncrementId(name) {
    if (!$99b18dd98d1424fc$var$globalIdMemo[name]) $99b18dd98d1424fc$var$globalIdMemo[name] = 0;
    return ++$99b18dd98d1424fc$var$globalIdMemo[name];
}
function $99b18dd98d1424fc$var$closestIdRoot(el, name) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $99b18dd98d1424fc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $99b18dd98d1424fc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$99b18dd98d1424fc$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $99b18dd98d1424fc$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $99b18dd98d1424fc$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$99b18dd98d1424fc$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$99b18dd98d1424fc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$99b18dd98d1424fc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $99b18dd98d1424fc$var$warnMissingPluginMagic(name, magicName, slug) {
    $99b18dd98d1424fc$var$magic(magicName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$99b18dd98d1424fc$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $99b18dd98d1424fc$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$99b18dd98d1424fc$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $99b18dd98d1424fc$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $99b18dd98d1424fc$var$skipDuringClone(()=>{
            $99b18dd98d1424fc$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $99b18dd98d1424fc$var$getTarget(expression);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$99b18dd98d1424fc$var$mutateDom(()=>{
            clone2.remove();
            $99b18dd98d1424fc$var$destroyTree(clone2);
        }));
});
var $99b18dd98d1424fc$var$teleportContainerDuringClone = document.createElement("div");
function $99b18dd98d1424fc$var$getTarget(expression) {
    let target = $99b18dd98d1424fc$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $99b18dd98d1424fc$var$teleportContainerDuringClone;
    })();
    if (!target) $99b18dd98d1424fc$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $99b18dd98d1424fc$var$handler = ()=>{};
$99b18dd98d1424fc$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$99b18dd98d1424fc$var$directive("ignore", $99b18dd98d1424fc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$99b18dd98d1424fc$var$directive("effect", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($99b18dd98d1424fc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $99b18dd98d1424fc$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $99b18dd98d1424fc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $99b18dd98d1424fc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($99b18dd98d1424fc$var$isKeyEvent(event) || $99b18dd98d1424fc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $99b18dd98d1424fc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $99b18dd98d1424fc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $99b18dd98d1424fc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $99b18dd98d1424fc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($99b18dd98d1424fc$var$isClickEvent(e.type)) return false;
            if ($99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $99b18dd98d1424fc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $99b18dd98d1424fc$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$99b18dd98d1424fc$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $99b18dd98d1424fc$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($99b18dd98d1424fc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $99b18dd98d1424fc$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $99b18dd98d1424fc$var$isCloning ? ()=>{} : $99b18dd98d1424fc$var$on(el, event, modifiers, (e)=>{
        setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $99b18dd98d1424fc$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $99b18dd98d1424fc$var$on(el.form, "reset", [], (e)=>{
            $99b18dd98d1424fc$var$nextTick(()=>el._x_model && el._x_model.set($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $99b18dd98d1424fc$var$getInputValue(el, modifiers, event, currentValue) {
    return $99b18dd98d1424fc$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $99b18dd98d1424fc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $99b18dd98d1424fc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$99b18dd98d1424fc$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($99b18dd98d1424fc$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $99b18dd98d1424fc$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $99b18dd98d1424fc$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $99b18dd98d1424fc$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $99b18dd98d1424fc$var$isNumeric2(number) ? number : rawValue;
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$99b18dd98d1424fc$var$directive("cloak", (el)=>queueMicrotask(()=>$99b18dd98d1424fc$var$mutateDom(()=>el.removeAttribute($99b18dd98d1424fc$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$99b18dd98d1424fc$var$addInitSelector(()=>`[${$99b18dd98d1424fc$var$prefix("init")}]`);
$99b18dd98d1424fc$var$directive("init", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$99b18dd98d1424fc$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$99b18dd98d1424fc$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $99b18dd98d1424fc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith(":", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("bind:"))));
var $99b18dd98d1424fc$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $99b18dd98d1424fc$var$injectBindingProviders(bindingProviders);
        let getBindings = $99b18dd98d1424fc$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $99b18dd98d1424fc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $99b18dd98d1424fc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$99b18dd98d1424fc$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$99b18dd98d1424fc$var$directive("bind", $99b18dd98d1424fc$var$handler2);
function $99b18dd98d1424fc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$99b18dd98d1424fc$var$addRootSelector(()=>`[${$99b18dd98d1424fc$var$prefix("data")}]`);
$99b18dd98d1424fc$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $99b18dd98d1424fc$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $99b18dd98d1424fc$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $99b18dd98d1424fc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $99b18dd98d1424fc$var$injectMagics(data2, el);
    let reactiveData = $99b18dd98d1424fc$var$reactive(data2);
    $99b18dd98d1424fc$var$initInterceptors(reactiveData);
    let undo = $99b18dd98d1424fc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$99b18dd98d1424fc$var$isCloning) return false;
    if ($99b18dd98d1424fc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$99b18dd98d1424fc$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $99b18dd98d1424fc$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$99b18dd98d1424fc$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $99b18dd98d1424fc$var$parseForExpression(expression);
    let evaluateItems = $99b18dd98d1424fc$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $99b18dd98d1424fc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($99b18dd98d1424fc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $99b18dd98d1424fc$var$mutateDom(()=>{
                if (!elForSpot) $99b18dd98d1424fc$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $99b18dd98d1424fc$var$reactive(scope2);
            $99b18dd98d1424fc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $99b18dd98d1424fc$var$mutateDom(()=>{
                lastEl.after(clone2);
                $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
            });
            if (typeof key === "object") $99b18dd98d1424fc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $99b18dd98d1424fc$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $99b18dd98d1424fc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $99b18dd98d1424fc$var$handler3() {}
$99b18dd98d1424fc$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $99b18dd98d1424fc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$99b18dd98d1424fc$var$directive("ref", $99b18dd98d1424fc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$99b18dd98d1424fc$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.after(clone2);
            $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$99b18dd98d1424fc$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$99b18dd98d1424fc$var$setIdRoot(el, name));
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith("@", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("on:"))));
$99b18dd98d1424fc$var$directive("on", $99b18dd98d1424fc$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $99b18dd98d1424fc$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $99b18dd98d1424fc$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$99b18dd98d1424fc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $99b18dd98d1424fc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $99b18dd98d1424fc$var$directive(directiveName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$99b18dd98d1424fc$var$alpine_default.setEvaluator($99b18dd98d1424fc$var$normalEvaluator);
$99b18dd98d1424fc$var$alpine_default.setRawEvaluator($99b18dd98d1424fc$var$normalRawEvaluator);
$99b18dd98d1424fc$var$alpine_default.setReactivityEngine({
    reactive: $99b18dd98d1424fc$var$reactive2,
    effect: $99b18dd98d1424fc$var$effect2,
    release: $99b18dd98d1424fc$var$stop,
    raw: $99b18dd98d1424fc$var$toRaw
});
var $99b18dd98d1424fc$export$b7ee041e4ad2afec = $99b18dd98d1424fc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $99b18dd98d1424fc$export$2e2bcd8739ae039 = $99b18dd98d1424fc$export$b7ee041e4ad2afec;


/**
 * Extends the Shopify object with additional routes.
 *
 * @type {Object}
 */ Shopify.routes.shop_url = `${document.location.origin}`;
/**
 * Extends the Shopify object with helper functions.
 *
 * @type {Object}
 */ Shopify.helpers = {
    asMoney: (0, $77eae7726dbdfc03$export$b28d0a0c2ceb8a25),
    wait: (0, $77eae7726dbdfc03$export$5c069c93d2b7493f),
    waitForElement: (0, $77eae7726dbdfc03$export$1a1c301579a08d1e)
};
/**
 * Dispatches a custom event with a payload.
 *
 * @param {String} event - The name of the event to dispatch.
 * @param {Object} payload - The payload to include with the event.
 */ function $b8588ef2626d5f88$var$dispatch(event, payload) {
    window.dispatchEvent(new CustomEvent(event, {
        detail: payload
    }));
}
/**
 * Adds a product to the cart.
 *
 * @link https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
 *
 * @param {Number} id - The variant ID to add to the cart.
 * @param {Number} quantity - The quantity of the variant to add to the cart.
 * @returns {Promise<Object>} A promise that:
 *  - resolves with an object containing the added item and cart data.
 *  - rejects with an error if the request fails.
 * @fires cart:adding
 * @fires cart:added
 * @fires cart:add:error
 */ function $b8588ef2626d5f88$var$add(id, quantity = 1) {
    let payload = {
        id: id,
        quantity: quantity
    };
    $b8588ef2626d5f88$var$dispatch('cart:adding', payload);
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then((item)=>{
            // the item has been added, but we now need to refresh the cart
            Shopify.cart.refresh().then(()=>{
                // there's a chance that the amount in the cart has exceeded the max, so we need to call change
                Shopify.cart.change(item.key, item.quantity).then(({ item: item, cart: cart })=>{
                    $b8588ef2626d5f88$var$dispatch('cart:added', item);
                    resolve({
                        item: item,
                        cart: cart
                    });
                }).catch((error)=>{
                    // Need to reword this error
                    if (error.message.includes('due to availability.')) error.message = 'You have the maximum amount of this item in your cart.';
                    reject(error);
                });
            }).catch((error)=>{
                reject(error);
            });
        }).catch((error)=>{
            $b8588ef2626d5f88$var$dispatch('cart:add:error', error);
            reject(error);
        });
    });
}
/**
 * Refreshes the cart by fetching the latest cart data from the server.
 *
 * @link https://shopify.dev/docs/api/ajax/reference/cart#get-locale-cart-js
 *
 * @returns {Promise<Object>} A promise that:
 *  - resolves with the refreshed cart data,
 *  - rejects with an error if the request fails.
 * @fires cart:refreshing
 * @fires cart:refreshed
 * @fires cart:refresh:error
 */ function $b8588ef2626d5f88$var$refresh() {
    $b8588ef2626d5f88$var$dispatch('cart:refreshing');
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>response.json()).then((cart)=>{
            $b8588ef2626d5f88$var$dispatch('cart:refreshed', cart);
            (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('cart', cart);
            resolve(cart);
        }).catch((error)=>{
            $b8588ef2626d5f88$var$dispatch('cart:refresh:error', error);
            reject(error);
        });
    });
}
/**
 * Changes the quantity of an item in the cart by sending a POST request to the server.
 *
 * @link https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
 *
 * @param {mixed} id - The Line Item ID (as string), or ID (as number) of the item to change. Defaults to 1.
 * @param {number} quantity - The new quantity of the item.
 * @returns {Promise<Object>} A promise that:
 *  - resolves with an object containing the changed item and cart data.
 *  - rejects with an error if the request fails.
 * 
 * @fires cart:changing
 * @fires cart:changed
 * @fires cart:change:error
 */ function $b8588ef2626d5f88$var$change(id, quantity = 1) {
    let payload = {
        id: id,
        quantity: quantity
    };
    $b8588ef2626d5f88$var$dispatch('cart:changing', payload);
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then((response)=>{
            $b8588ef2626d5f88$var$dispatch('cart:changed', response);
            // 422 indicates a stock error
            if (response.status === 422) reject(response);
            // refresh the cart
            Shopify.cart.refresh().then((cart)=>{
                resolve(cart);
            }).catch((error)=>{
                reject(error);
            });
        }).catch((error)=>{
            $b8588ef2626d5f88$var$dispatch('cart:change:error', error);
            reject(error);
        });
    });
}
/**
 * Removes an item from the cart by calling `Shopify.Cart.change` with a quantity of 0.
 *
 * @link https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-clear-js
 *
 * @param {mixed} id - The Line Item ID (as string), or ID (as number) of the item to remove.
 * @returns {Promise<Object>} A promise that:
 *  - resolves with an object containing the changed item and cart data.
 *  - rejects with an error if the request fails.
 * 
 * @see Shopify.cart.change
 */ function $b8588ef2626d5f88$var$remove(id) {
    return Shopify.cart.change(id, 0);
}
/**
 * Clears the cart by sending a POST request to the server.
 *
 * @link https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-clear-js
 *
 * @returns {Promise<Object>} A promise that:
 *  - resolves with the cleared cart data.
 *  - rejects with an error if the request fails.
 * 
 * @fires cart:clearing
 * @fires cart:cleared
 * @fires cart:clear:error
 */ function $b8588ef2626d5f88$var$clear() {
    $b8588ef2626d5f88$var$dispatch('cart:clearing');
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart/clear.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>response.json()).then((cart)=>{
            $b8588ef2626d5f88$var$dispatch('cart:cleared', cart);
            resolve(cart);
        }).catch((error)=>{
            $b8588ef2626d5f88$var$dispatch('cart:clear:error', error);
            reject(error);
        });
    });
}
/**
 * Helper to build and validate shipping rates query string.
 *
 * @param {string} zip
 * @param {string} country
 * @param {string} province
 * @returns {string} query string
 * @throws {Error} if no parameters provided
 */ function $b8588ef2626d5f88$var$buildShippingQueryString(zip, country, province) {
    const query = {};
    if (zip) query['shipping_address[zip]'] = zip;
    if (country) query['shipping_address[country]'] = country;
    if (province) query['shipping_address[province]'] = province;
    if (Object.keys(query).length === 0) throw new Error('At least one of zip, country, or province must be provided.');
    return new URLSearchParams(query).toString();
}
function $b8588ef2626d5f88$var$prepareShippingRates(zip, country, province) {
    let queryString;
    try {
        queryString = $b8588ef2626d5f88$var$buildShippingQueryString(zip, country, province);
    } catch (error) {
        return Promise.reject(error);
    }
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?${queryString}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            resolve(data);
        }).catch((error)=>{
            reject(error);
        });
    });
}
function $b8588ef2626d5f88$var$asyncShippingRates(zip, country, province) {
    let queryString;
    try {
        queryString = $b8588ef2626d5f88$var$buildShippingQueryString(zip, country, province);
    } catch (error) {
        return Promise.reject(error);
    }
    return new Promise((resolve, reject)=>{
        fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?${queryString}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (!response.ok) return response.json().then((errorData)=>{
                reject(new Error(`HTTP error ${response.status}: ${response.statusText}`, {
                    cause: errorData
                }));
            });
            return response.json();
        }).then((data)=>{
            resolve(data);
        }).catch((error)=>{
            reject(error);
        });
    });
}
// Initialize any events or listeners here
function $b8588ef2626d5f88$var$initEvents() {
    // Example: Listen for cart refresh events to log the cart data
    window.addEventListener('cart:refresh', (event)=>{
        $b8588ef2626d5f88$var$refresh();
    });
    window.addEventListener('cart:change', (event)=>{
        const { id: id, quantity: quantity } = event.detail;
        $b8588ef2626d5f88$var$change(id, quantity);
    });
    window.addEventListener('cart:add', (event)=>{
        const { id: id, quantity: quantity } = event.detail;
        $b8588ef2626d5f88$var$add(id, quantity);
    });
    window.addEventListener('cart:remove', (event)=>{
        const { id: id } = event.detail;
        $b8588ef2626d5f88$var$remove(id);
    });
}
$b8588ef2626d5f88$var$initEvents();
/**
 * Extends the Shopify object with cart functions.
 *
 * @type {Object}
 */ Shopify.cart = {
    add: $b8588ef2626d5f88$var$add,
    change: $b8588ef2626d5f88$var$change,
    remove: $b8588ef2626d5f88$var$remove,
    clear: $b8588ef2626d5f88$var$clear,
    refresh: $b8588ef2626d5f88$var$refresh,
    prepareShippingRates: $b8588ef2626d5f88$var$prepareShippingRates,
    asyncShippingRates: $b8588ef2626d5f88$var$asyncShippingRates
};


/**
 * Fuse.js v7.5.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2026 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ //#region src/helpers/typeGuards.ts
function $aef5620a7182edcc$var$isArray(value) {
    return !Array.isArray ? $aef5620a7182edcc$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
function $aef5620a7182edcc$var$baseToString(value) {
    if (typeof value == "string") return value;
    if (typeof value === "bigint") return value.toString();
    const result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function $aef5620a7182edcc$var$toString(value) {
    return value == null ? "" : $aef5620a7182edcc$var$baseToString(value);
}
function $aef5620a7182edcc$var$isString(value) {
    return typeof value === "string";
}
function $aef5620a7182edcc$var$isNumber(value) {
    return typeof value === "number";
}
function $aef5620a7182edcc$var$isBoolean(value) {
    return value === true || value === false || $aef5620a7182edcc$var$isObjectLike(value) && $aef5620a7182edcc$var$getTag(value) == "[object Boolean]";
}
function $aef5620a7182edcc$var$isObject(value) {
    return typeof value === "object";
}
function $aef5620a7182edcc$var$isObjectLike(value) {
    return $aef5620a7182edcc$var$isObject(value) && value !== null;
}
function $aef5620a7182edcc$var$isDefined(value) {
    return value !== void 0 && value !== null;
}
function $aef5620a7182edcc$var$isBlank(value) {
    return !value.trim().length;
}
function $aef5620a7182edcc$var$getTag(value) {
    return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
//#endregion
//#region src/core/errorMessages.ts
const $aef5620a7182edcc$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $aef5620a7182edcc$var$INVALID_DOC_INDEX = "Invalid doc index: must be a non-negative integer within the bounds of the docs array";
const $aef5620a7182edcc$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $aef5620a7182edcc$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $aef5620a7182edcc$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $aef5620a7182edcc$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $aef5620a7182edcc$var$FUSE_MATCH_TOKEN_SEARCH_UNSUPPORTED = "Fuse.match does not support useTokenSearch: token search requires corpus-level statistics (df, fieldCount) that a one-off string comparison does not have. Use new Fuse(...).search(...) instead.";
//#endregion
//#region src/tools/KeyStore.ts
const $aef5620a7182edcc$var$hasOwn = Object.prototype.hasOwnProperty;
var $aef5620a7182edcc$var$KeyStore = class {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            const obj = $aef5620a7182edcc$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
};
function $aef5620a7182edcc$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($aef5620a7182edcc$var$isString(key) || $aef5620a7182edcc$var$isArray(key)) {
        src = key;
        path = $aef5620a7182edcc$var$createKeyPath(key);
        id = $aef5620a7182edcc$var$createKeyId(key);
    } else {
        if (!$aef5620a7182edcc$var$hasOwn.call(key, "name")) throw new Error($aef5620a7182edcc$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($aef5620a7182edcc$var$hasOwn.call(key, "weight") && key.weight !== void 0) {
            weight = key.weight;
            if (weight <= 0) throw new Error($aef5620a7182edcc$var$INVALID_KEY_WEIGHT_VALUE($aef5620a7182edcc$var$createKeyId(name)));
        }
        path = $aef5620a7182edcc$var$createKeyPath(name);
        id = $aef5620a7182edcc$var$createKeyId(name);
        getFn = key.getFn ?? null;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $aef5620a7182edcc$var$createKeyPath(key) {
    return $aef5620a7182edcc$var$isArray(key) ? key : key.split(".");
}
function $aef5620a7182edcc$var$createKeyId(key) {
    return $aef5620a7182edcc$var$isArray(key) ? key.join(".") : key;
}
//#endregion
//#region src/helpers/get.ts
function $aef5620a7182edcc$var$get(obj, path) {
    const list = [];
    let arr = false;
    const deepGet = (obj, path, index, arrayIndex)=>{
        if (!$aef5620a7182edcc$var$isDefined(obj)) return;
        if (!path[index]) list.push(arrayIndex !== void 0 ? {
            v: obj,
            i: arrayIndex
        } : obj);
        else {
            const value = obj[path[index]];
            if (!$aef5620a7182edcc$var$isDefined(value)) return;
            if (index === path.length - 1 && ($aef5620a7182edcc$var$isString(value) || $aef5620a7182edcc$var$isNumber(value) || $aef5620a7182edcc$var$isBoolean(value) || typeof value === "bigint")) list.push(arrayIndex !== void 0 ? {
                v: $aef5620a7182edcc$var$toString(value),
                i: arrayIndex
            } : $aef5620a7182edcc$var$toString(value));
            else if ($aef5620a7182edcc$var$isArray(value)) {
                arr = true;
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1, i);
            } else if (path.length) deepGet(value, path, index + 1, arrayIndex);
        }
    };
    deepGet(obj, $aef5620a7182edcc$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
//#endregion
//#region src/core/config.ts
const $aef5620a7182edcc$var$MatchOptions = {
    includeMatches: false,
    findAllMatches: false,
    minMatchCharLength: 1
};
const $aef5620a7182edcc$var$BasicOptions = {
    isCaseSensitive: false,
    ignoreDiacritics: false,
    includeScore: false,
    keys: [],
    shouldSort: true,
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $aef5620a7182edcc$var$FuzzyOptions = {
    location: 0,
    threshold: .6,
    distance: 100
};
const $aef5620a7182edcc$var$AdvancedOptions = {
    useExtendedSearch: false,
    useTokenSearch: false,
    tokenize: void 0,
    tokenMatch: "any",
    getFn: $aef5620a7182edcc$var$get,
    ignoreLocation: false,
    ignoreFieldNorm: false,
    fieldNormWeight: 1
};
const $aef5620a7182edcc$var$Config = Object.freeze({
    ...$aef5620a7182edcc$var$BasicOptions,
    ...$aef5620a7182edcc$var$MatchOptions,
    ...$aef5620a7182edcc$var$FuzzyOptions,
    ...$aef5620a7182edcc$var$AdvancedOptions
});
//#endregion
//#region src/tools/fieldNorm.ts
function $aef5620a7182edcc$var$isWordSeparator(code) {
    return code >= 9 && code <= 13 || code === 32 || code === 160;
}
function $aef5620a7182edcc$var$norm(weight = 1, mantissa = 3) {
    const cache = /* @__PURE__ */ new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            let numTokens = 0;
            let inWord = false;
            for(let i = 0; i < value.length; i++)if (!$aef5620a7182edcc$var$isWordSeparator(value.charCodeAt(i))) {
                if (!inWord) {
                    numTokens++;
                    inWord = true;
                }
            } else inWord = false;
            if (numTokens === 0) numTokens = 1;
            if (cache.has(numTokens)) return cache.get(numTokens);
            const n = Math.round(m / Math.pow(numTokens, .5 * weight)) / m;
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
//#endregion
//#region src/tools/FuseIndex.ts
var $aef5620a7182edcc$var$FuseIndex = class {
    constructor({ getFn: getFn = $aef5620a7182edcc$var$Config.getFn, fieldNormWeight: fieldNormWeight = $aef5620a7182edcc$var$Config.fieldNormWeight } = {}){
        this.norm = $aef5620a7182edcc$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.docs = [];
        this.keys = [];
        this._keysMap = {};
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        const len = this.docs.length;
        this.records = new Array(len);
        let recordCount = 0;
        if ($aef5620a7182edcc$var$isString(this.docs[0])) for(let i = 0; i < len; i++){
            const record = this._createStringRecord(this.docs[i], i);
            if (record) this.records[recordCount++] = record;
        }
        else for(let i = 0; i < len; i++)this.records[recordCount++] = this._createObjectRecord(this.docs[i], i);
        this.records.length = recordCount;
        this.norm.clear();
    }
    add(doc, docIndex) {
        if (!Number.isInteger(docIndex) || docIndex < 0) throw new Error($aef5620a7182edcc$var$INVALID_DOC_INDEX);
        if ($aef5620a7182edcc$var$isString(doc)) {
            const record = this._createStringRecord(doc, docIndex);
            if (record) this.records.push(record);
            return record;
        }
        const record = this._createObjectRecord(doc, docIndex);
        this.records.push(record);
        return record;
    }
    removeAt(idx) {
        if (!Number.isInteger(idx) || idx < 0) throw new Error($aef5620a7182edcc$var$INVALID_DOC_INDEX);
        for(let i = 0, len = this.records.length; i < len; i += 1)if (this.records[i].i === idx) {
            this.records.splice(i, 1);
            break;
        }
        for(let i = 0, len = this.records.length; i < len; i += 1)if (this.records[i].i > idx) this.records[i].i -= 1;
    }
    removeAll(indices) {
        const toRemove = /* @__PURE__ */ new Set();
        for (const v of indices)if (Number.isInteger(v) && v >= 0) toRemove.add(v);
        if (toRemove.size === 0) return;
        this.records = this.records.filter((r)=>!toRemove.has(r.i));
        const sorted = Array.from(toRemove).sort((a, b)=>a - b);
        for (const record of this.records){
            let lo = 0;
            let hi = sorted.length;
            while(lo < hi){
                const mid = lo + hi >>> 1;
                if (sorted[mid] < record.i) lo = mid + 1;
                else hi = mid;
            }
            record.i -= lo;
        }
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _createStringRecord(doc, docIndex) {
        if (!$aef5620a7182edcc$var$isDefined(doc) || $aef5620a7182edcc$var$isBlank(doc)) return null;
        return {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
    }
    _createObjectRecord(doc, docIndex) {
        const record = {
            i: docIndex,
            $: {}
        };
        for(let keyIndex = 0, keyLen = this.keys.length; keyIndex < keyLen; keyIndex++){
            const key = this.keys[keyIndex];
            const value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$aef5620a7182edcc$var$isDefined(value)) continue;
            if ($aef5620a7182edcc$var$isArray(value)) {
                const subRecords = [];
                for(let i = 0, len = value.length; i < len; i += 1){
                    const item = value[i];
                    if (!$aef5620a7182edcc$var$isDefined(item)) continue;
                    if ($aef5620a7182edcc$var$isString(item)) {
                        if (!$aef5620a7182edcc$var$isBlank(item)) {
                            const subRecord = {
                                v: item,
                                i: i,
                                n: this.norm.get(item)
                            };
                            subRecords.push(subRecord);
                        }
                    } else if ($aef5620a7182edcc$var$isDefined(item.v)) {
                        const text = $aef5620a7182edcc$var$isString(item.v) ? item.v : $aef5620a7182edcc$var$toString(item.v);
                        if (!$aef5620a7182edcc$var$isBlank(text)) {
                            const subRecord = {
                                v: text,
                                i: item.i,
                                n: this.norm.get(text)
                            };
                            subRecords.push(subRecord);
                        }
                    }
                }
                record.$[keyIndex] = subRecords;
            } else if ($aef5620a7182edcc$var$isString(value) && !$aef5620a7182edcc$var$isBlank(value)) {
                const subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        }
        return record;
    }
    toJSON() {
        return {
            keys: this.keys.map(({ getFn: getFn, ...key })=>key),
            records: this.records
        };
    }
};
function $aef5620a7182edcc$var$createIndex(keys, docs, { getFn: getFn = $aef5620a7182edcc$var$Config.getFn, fieldNormWeight: fieldNormWeight = $aef5620a7182edcc$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $aef5620a7182edcc$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($aef5620a7182edcc$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $aef5620a7182edcc$var$parseIndex(data, { getFn: getFn = $aef5620a7182edcc$var$Config.getFn, fieldNormWeight: fieldNormWeight = $aef5620a7182edcc$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $aef5620a7182edcc$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
//#endregion
//#region src/search/bitap/convertMaskToIndices.ts
function $aef5620a7182edcc$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $aef5620a7182edcc$var$Config.minMatchCharLength) {
    const indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        const match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
//#endregion
//#region src/search/bitap/search.ts
function $aef5620a7182edcc$var$search(text, pattern, patternAlphabet, { location: location = $aef5620a7182edcc$var$Config.location, distance: distance = $aef5620a7182edcc$var$Config.distance, threshold: threshold = $aef5620a7182edcc$var$Config.threshold, findAllMatches: findAllMatches = $aef5620a7182edcc$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $aef5620a7182edcc$var$Config.minMatchCharLength, includeMatches: includeMatches = $aef5620a7182edcc$var$Config.includeMatches, ignoreLocation: ignoreLocation = $aef5620a7182edcc$var$Config.ignoreLocation } = {}) {
    if (pattern.length > 32) throw new Error($aef5620a7182edcc$var$PATTERN_LENGTH_TOO_LARGE(32));
    const patternLen = pattern.length;
    const textLen = text.length;
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    let currentThreshold = threshold;
    let bestLocation = expectedLocation;
    const calcScore = (errors, currentLocation)=>{
        const accuracy = errors / patternLen;
        if (ignoreLocation) return accuracy;
        const proximity = Math.abs(expectedLocation - currentLocation);
        if (!distance) return proximity ? 1 : accuracy;
        return accuracy + proximity / distance;
    };
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        const score = calcScore(0, index);
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let bestErrors = 0;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            if (calcScore(i, expectedLocation + binMid) <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        const finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        const bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            const currentLocation = j - 1;
            const charMatch = patternAlphabet[text[currentLocation]];
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = calcScore(i, currentLocation);
                if (finalScore <= currentThreshold) {
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    bestErrors = i;
                    if (bestLocation <= expectedLocation) break;
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        if (calcScore(i + 1, expectedLocation) > currentThreshold) break;
        lastBitArr = bitArr;
    }
    if (computeMatches && bestLocation >= 0) {
        const matchEnd = Math.min(textLen - 1, bestLocation + patternLen - 1 + bestErrors);
        for(let k = bestLocation; k <= matchEnd; k += 1)if (patternAlphabet[text[k]]) matchMask[k] = 1;
    }
    const result = {
        isMatch: bestLocation >= 0,
        score: Math.max(.001, finalScore)
    };
    if (computeMatches) {
        const indices = $aef5620a7182edcc$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
//#endregion
//#region src/search/bitap/createPatternAlphabet.ts
function $aef5620a7182edcc$var$createPatternAlphabet(pattern) {
    const mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
//#endregion
//#region src/helpers/mergeIndices.ts
function $aef5620a7182edcc$var$mergeIndices(indices) {
    if (indices.length <= 1) return indices;
    indices.sort((a, b)=>a[0] - b[0] || a[1] - b[1]);
    const merged = [
        indices[0]
    ];
    for(let i = 1, len = indices.length; i < len; i += 1){
        const last = merged[merged.length - 1];
        const curr = indices[i];
        if (curr[0] <= last[1] + 1) last[1] = Math.max(last[1], curr[1]);
        else merged.push(curr);
    }
    return merged;
}
//#endregion
//#region src/helpers/diacritics.ts
const $aef5620a7182edcc$var$NON_DECOMPOSABLE_MAP = {
    "\u0142": "l",
    "\u0141": "L",
    "\u0111": "d",
    "\u0110": "D",
    "\xf8": "o",
    "\xd8": "O",
    "\u0127": "h",
    "\u0126": "H",
    "\u0167": "t",
    "\u0166": "T",
    "\u0131": "i",
    "\xdf": "ss"
};
const $aef5620a7182edcc$var$NON_DECOMPOSABLE_RE = new RegExp("[" + Object.keys($aef5620a7182edcc$var$NON_DECOMPOSABLE_MAP).join("") + "]", "g");
const $aef5620a7182edcc$var$stripDiacritics = typeof String.prototype.normalize === "function" ? (str)=>str.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "").replace($aef5620a7182edcc$var$NON_DECOMPOSABLE_RE, (ch)=>$aef5620a7182edcc$var$NON_DECOMPOSABLE_MAP[ch]) : (str)=>str;
//#endregion
//#region src/search/bitap/index.ts
var $aef5620a7182edcc$var$BitapSearch = class {
    constructor(pattern, { location: location = $aef5620a7182edcc$var$Config.location, threshold: threshold = $aef5620a7182edcc$var$Config.threshold, distance: distance = $aef5620a7182edcc$var$Config.distance, includeMatches: includeMatches = $aef5620a7182edcc$var$Config.includeMatches, findAllMatches: findAllMatches = $aef5620a7182edcc$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $aef5620a7182edcc$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $aef5620a7182edcc$var$Config.isCaseSensitive, ignoreDiacritics: ignoreDiacritics = $aef5620a7182edcc$var$Config.ignoreDiacritics, ignoreLocation: ignoreLocation = $aef5620a7182edcc$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreDiacritics: ignoreDiacritics,
            ignoreLocation: ignoreLocation
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? $aef5620a7182edcc$var$stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $aef5620a7182edcc$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > 32) {
            let i = 0;
            const remainder = len % 32;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, 32), i);
                i += 32;
            }
            if (remainder) {
                const startIndex = len - 32;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, ignoreDiacritics: ignoreDiacritics, includeMatches: includeMatches } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        text = ignoreDiacritics ? $aef5620a7182edcc$var$stripDiacritics(text) : text;
        if (this.pattern === text) {
            if (text.length < this.options.minMatchCharLength) return {
                isMatch: false,
                score: 1
            };
            const result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        const allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $aef5620a7182edcc$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices.push(...indices);
        });
        const result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = $aef5620a7182edcc$var$mergeIndices(allIndices);
        return result;
    }
};
//#endregion
//#region src/search/extended/matchers.ts
const $aef5620a7182edcc$var$MULTI_MATCH_TYPES = new Set([
    "fuzzy",
    "include"
]);
function $aef5620a7182edcc$var$isInverse(type) {
    return type.startsWith("inverse");
}
const $aef5620a7182edcc$var$matchers = [
    {
        type: "exact",
        multiRegex: /^="(.*)"$/,
        singleRegex: /^=(.*)$/,
        create: (pattern)=>({
                type: "exact",
                search (text) {
                    const isMatch = text === pattern;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            pattern.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "include",
        multiRegex: /^'"(.*)"$/,
        singleRegex: /^'(.*)$/,
        create: (pattern)=>({
                type: "include",
                search (text) {
                    let location = 0;
                    let index;
                    const indices = [];
                    const patternLen = pattern.length;
                    while((index = text.indexOf(pattern, location)) > -1){
                        location = index + patternLen;
                        indices.push([
                            index,
                            location - 1
                        ]);
                    }
                    const isMatch = !!indices.length;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: indices
                    };
                }
            })
    },
    {
        type: "prefix-exact",
        multiRegex: /^\^"(.*)"$/,
        singleRegex: /^\^(.*)$/,
        create: (pattern)=>({
                type: "prefix-exact",
                search (text) {
                    const isMatch = text.startsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            pattern.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "inverse-prefix-exact",
        multiRegex: /^!\^"(.*)"$/,
        singleRegex: /^!\^(.*)$/,
        create: (pattern)=>({
                type: "inverse-prefix-exact",
                search (text) {
                    const isMatch = !text.startsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "inverse-suffix-exact",
        multiRegex: /^!"(.*)"\$$/,
        singleRegex: /^!(.*)\$$/,
        create: (pattern)=>({
                type: "inverse-suffix-exact",
                search (text) {
                    const isMatch = !text.endsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "suffix-exact",
        multiRegex: /^"(.*)"\$$/,
        singleRegex: /^(.*)\$$/,
        create: (pattern)=>({
                type: "suffix-exact",
                search (text) {
                    const isMatch = text.endsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            text.length - pattern.length,
                            text.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "inverse-exact",
        multiRegex: /^!"(.*)"$/,
        singleRegex: /^!(.*)$/,
        create: (pattern)=>({
                type: "inverse-exact",
                search (text) {
                    const isMatch = text.indexOf(pattern) === -1;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            })
    },
    {
        type: "fuzzy",
        multiRegex: /^"(.*)"$/,
        singleRegex: /^(.*)$/,
        create: (pattern, options = {})=>{
            const bitap = new $aef5620a7182edcc$var$BitapSearch(pattern, {
                location: options.location ?? $aef5620a7182edcc$var$Config.location,
                threshold: options.threshold ?? $aef5620a7182edcc$var$Config.threshold,
                distance: options.distance ?? $aef5620a7182edcc$var$Config.distance,
                includeMatches: options.includeMatches ?? $aef5620a7182edcc$var$Config.includeMatches,
                findAllMatches: options.findAllMatches ?? $aef5620a7182edcc$var$Config.findAllMatches,
                minMatchCharLength: options.minMatchCharLength ?? $aef5620a7182edcc$var$Config.minMatchCharLength,
                isCaseSensitive: options.isCaseSensitive ?? $aef5620a7182edcc$var$Config.isCaseSensitive,
                ignoreDiacritics: options.ignoreDiacritics ?? $aef5620a7182edcc$var$Config.ignoreDiacritics,
                ignoreLocation: options.ignoreLocation ?? $aef5620a7182edcc$var$Config.ignoreLocation
            });
            return {
                type: "fuzzy",
                search (text) {
                    return bitap.searchIn(text);
                }
            };
        }
    }
];
//#endregion
//#region src/search/extended/parseQuery.ts
const $aef5620a7182edcc$var$matchersLen = $aef5620a7182edcc$var$matchers.length;
const $aef5620a7182edcc$var$ESCAPED_PIPE = "\0";
const $aef5620a7182edcc$var$OR_TOKEN = "|";
function $aef5620a7182edcc$var$tokenize(pattern) {
    const tokens = [];
    const len = pattern.length;
    let i = 0;
    while(i < len){
        while(i < len && pattern[i] === " ")i++;
        if (i >= len) break;
        let j = i;
        while(j < len && pattern[j] !== " " && pattern[j] !== "\"")j++;
        if (j < len && pattern[j] === "\"") {
            j++;
            while(j < len){
                if (pattern[j] === "\"") {
                    const next = j + 1;
                    if (next >= len || pattern[next] === " ") {
                        j++;
                        break;
                    }
                    if (pattern[next] === "$" && (next + 1 >= len || pattern[next + 1] === " ")) {
                        j += 2;
                        break;
                    }
                }
                j++;
            }
            tokens.push(pattern.substring(i, j));
            i = j;
        } else {
            while(j < len && pattern[j] !== " ")j++;
            tokens.push(pattern.substring(i, j));
            i = j;
        }
    }
    return tokens;
}
function $aef5620a7182edcc$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
function $aef5620a7182edcc$var$parseQuery(pattern, options = {}) {
    return pattern.replace(/\\\|/g, $aef5620a7182edcc$var$ESCAPED_PIPE).split($aef5620a7182edcc$var$OR_TOKEN).map((item)=>{
        const query = $aef5620a7182edcc$var$tokenize(item.replace(/\u0000/g, "|").trim()).filter((item)=>item && !!item.trim());
        const results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            let found = false;
            let idx = -1;
            while(!found && ++idx < $aef5620a7182edcc$var$matchersLen){
                const def = $aef5620a7182edcc$var$matchers[idx];
                const token = $aef5620a7182edcc$var$getMatch(queryItem, def.multiRegex);
                if (token) {
                    results.push(def.create(token, options));
                    found = true;
                }
            }
            if (found) continue;
            idx = -1;
            while(++idx < $aef5620a7182edcc$var$matchersLen){
                const def = $aef5620a7182edcc$var$matchers[idx];
                const token = $aef5620a7182edcc$var$getMatch(queryItem, def.singleRegex);
                if (token) {
                    results.push(def.create(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
//#endregion
//#region src/search/extended/index.ts
var $aef5620a7182edcc$var$ExtendedSearch = class {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $aef5620a7182edcc$var$Config.isCaseSensitive, ignoreDiacritics: ignoreDiacritics = $aef5620a7182edcc$var$Config.ignoreDiacritics, includeMatches: includeMatches = $aef5620a7182edcc$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $aef5620a7182edcc$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $aef5620a7182edcc$var$Config.ignoreLocation, findAllMatches: findAllMatches = $aef5620a7182edcc$var$Config.findAllMatches, location: location = $aef5620a7182edcc$var$Config.location, threshold: threshold = $aef5620a7182edcc$var$Config.threshold, distance: distance = $aef5620a7182edcc$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            ignoreDiacritics: ignoreDiacritics,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? $aef5620a7182edcc$var$stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.query = $aef5620a7182edcc$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive, ignoreDiacritics: ignoreDiacritics } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        text = ignoreDiacritics ? $aef5620a7182edcc$var$stripDiacritics(text) : text;
        let numMatches = 0;
        const allIndices = [];
        let totalScore = 0;
        let hasInverse = false;
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            allIndices.length = 0;
            numMatches = 0;
            hasInverse = false;
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const matcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = matcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if ($aef5620a7182edcc$var$isInverse(matcher.type)) hasInverse = true;
                    if (includeMatches) {
                        if ($aef5620a7182edcc$var$MULTI_MATCH_TYPES.has(matcher.type)) allIndices.push(...indices);
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    hasInverse = false;
                    break;
                }
            }
            if (numMatches) {
                const result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (hasInverse) result.hasInverse = true;
                if (includeMatches) result.indices = $aef5620a7182edcc$var$mergeIndices(allIndices);
                return result;
            }
        }
        return {
            isMatch: false,
            score: 1
        };
    }
};
//#endregion
//#region src/core/register.ts
const $aef5620a7182edcc$var$registeredSearchers = [];
function $aef5620a7182edcc$var$register(...args) {
    $aef5620a7182edcc$var$registeredSearchers.push(...args);
}
function $aef5620a7182edcc$var$createSearcher(pattern, options) {
    for(let i = 0, len = $aef5620a7182edcc$var$registeredSearchers.length; i < len; i += 1){
        const searcherClass = $aef5620a7182edcc$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $aef5620a7182edcc$var$BitapSearch(pattern, options);
}
//#endregion
//#region src/core/queryParser.ts
const $aef5620a7182edcc$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $aef5620a7182edcc$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $aef5620a7182edcc$var$isExpression = (query)=>!!(query[$aef5620a7182edcc$var$LogicalOperator.AND] || query[$aef5620a7182edcc$var$LogicalOperator.OR]);
const $aef5620a7182edcc$var$isPath = (query)=>!!query[$aef5620a7182edcc$var$KeyType.PATH];
const $aef5620a7182edcc$var$isLeaf = (query)=>!$aef5620a7182edcc$var$isArray(query) && $aef5620a7182edcc$var$isObject(query) && !$aef5620a7182edcc$var$isExpression(query);
const $aef5620a7182edcc$var$convertToExplicit = (query)=>({
        [$aef5620a7182edcc$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
function $aef5620a7182edcc$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        if ($aef5620a7182edcc$var$isString(query)) {
            const obj = {
                keyId: null,
                pattern: query
            };
            if (auto) obj.searcher = $aef5620a7182edcc$var$createSearcher(query, options);
            return obj;
        }
        const keys = Object.keys(query);
        const isQueryPath = $aef5620a7182edcc$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$aef5620a7182edcc$var$isExpression(query)) return next($aef5620a7182edcc$var$convertToExplicit(query));
        if ($aef5620a7182edcc$var$isLeaf(query)) {
            const key = isQueryPath ? query[$aef5620a7182edcc$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$aef5620a7182edcc$var$KeyType.PATTERN] : query[key];
            if (!$aef5620a7182edcc$var$isString(pattern)) throw new Error($aef5620a7182edcc$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $aef5620a7182edcc$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $aef5620a7182edcc$var$createSearcher(pattern, options);
            return obj;
        }
        const node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($aef5620a7182edcc$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$aef5620a7182edcc$var$isExpression(query)) query = $aef5620a7182edcc$var$convertToExplicit(query);
    return next(query);
}
//#endregion
//#region src/core/computeScore.ts
function $aef5620a7182edcc$var$computeScoreSingle(matches, { ignoreFieldNorm: ignoreFieldNorm = $aef5620a7182edcc$var$Config.ignoreFieldNorm }) {
    let totalScore = 1;
    matches.forEach(({ key: key, norm: norm, score: score })=>{
        const weight = key ? key.weight : null;
        totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
    });
    return totalScore;
}
function $aef5620a7182edcc$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $aef5620a7182edcc$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        result.score = $aef5620a7182edcc$var$computeScoreSingle(result.matches, {
            ignoreFieldNorm: ignoreFieldNorm
        });
    });
}
//#endregion
//#region src/tools/MaxHeap.ts
var $aef5620a7182edcc$var$MaxHeap = class {
    constructor(limit, comparator){
        this.limit = limit;
        this.heap = [];
        this.comparator = comparator;
    }
    get size() {
        return this.heap.length;
    }
    insert(item) {
        if (this.size < this.limit) {
            this.heap.push(item);
            this._bubbleUp(this.size - 1);
        } else if (this.comparator(item, this.heap[0]) < 0) {
            this.heap[0] = item;
            this._sinkDown(0);
        }
    }
    extractSorted() {
        return this.heap.sort(this.comparator);
    }
    _bubbleUp(i) {
        const heap = this.heap;
        while(i > 0){
            const parent = i - 1 >> 1;
            if (this.comparator(heap[i], heap[parent]) <= 0) break;
            const tmp = heap[i];
            heap[i] = heap[parent];
            heap[parent] = tmp;
            i = parent;
        }
    }
    _sinkDown(i) {
        const heap = this.heap;
        const len = heap.length;
        let largest = i;
        do {
            i = largest;
            const left = 2 * i + 1;
            const right = 2 * i + 2;
            if (left < len && this.comparator(heap[left], heap[largest]) > 0) largest = left;
            if (right < len && this.comparator(heap[right], heap[largest]) > 0) largest = right;
            if (largest !== i) {
                const tmp = heap[i];
                heap[i] = heap[largest];
                heap[largest] = tmp;
            }
        }while (largest !== i);
    }
};
//#endregion
//#region src/core/formatMatches.ts
function $aef5620a7182edcc$var$formatMatches(result) {
    const matches = [];
    result.matches.forEach((match)=>{
        if (!$aef5620a7182edcc$var$isDefined(match.indices) || !match.indices.length) return;
        const obj = {
            indices: match.indices,
            value: match.value
        };
        if (match.key) obj.key = match.key.id;
        if (match.idx > -1) obj.refIndex = match.idx;
        matches.push(obj);
    });
    return matches;
}
//#endregion
//#region src/core/format.ts
function $aef5620a7182edcc$var$format(results, docs, { includeMatches: includeMatches = $aef5620a7182edcc$var$Config.includeMatches, includeScore: includeScore = $aef5620a7182edcc$var$Config.includeScore } = {}) {
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (includeMatches) data.matches = $aef5620a7182edcc$var$formatMatches(result);
        if (includeScore) data.score = result.score;
        return data;
    });
}
//#endregion
//#region src/search/token/analyzer.ts
const $aef5620a7182edcc$var$DEFAULT_TOKEN = /[\p{L}\p{M}\p{N}_]+/gu;
const $aef5620a7182edcc$var$warned = /* @__PURE__ */ new WeakSet();
function $aef5620a7182edcc$var$warnNonGlobal(regex) {
    if (!$aef5620a7182edcc$var$warned.has(regex)) {
        $aef5620a7182edcc$var$warned.add(regex);
        console.warn(`[Fuse] tokenize regex ${regex} lacks the global flag; only the first match per text will be returned. Add the 'g' flag.`);
    }
}
function $aef5620a7182edcc$var$resolveTokenize(tokenize) {
    if (typeof tokenize === "function") {
        let validated = false;
        return (text)=>{
            const result = tokenize(text);
            if (!validated) {
                validated = true;
                if (!Array.isArray(result) || result.some((t)=>typeof t !== "string")) throw new Error(`[Fuse] tokenize function must return string[]; received ${Array.isArray(result) ? "array containing non-strings" : typeof result}.`);
            }
            return result;
        };
    }
    if (tokenize instanceof RegExp) {
        if (!tokenize.global) $aef5620a7182edcc$var$warnNonGlobal(tokenize);
        return (text)=>text.match(tokenize) || [];
    }
    return (text)=>text.match($aef5620a7182edcc$var$DEFAULT_TOKEN) || [];
}
function $aef5620a7182edcc$var$createAnalyzer({ isCaseSensitive: isCaseSensitive = false, ignoreDiacritics: ignoreDiacritics = false, tokenize: tokenize } = {}) {
    const tokenizeFn = $aef5620a7182edcc$var$resolveTokenize(tokenize);
    return {
        tokenize (text) {
            if (!isCaseSensitive) text = text.toLowerCase();
            if (ignoreDiacritics) text = $aef5620a7182edcc$var$stripDiacritics(text);
            return tokenizeFn(text);
        }
    };
}
//#endregion
//#region src/search/token/index.ts
const $aef5620a7182edcc$var$MAX_MASK_TERMS = 31;
var $aef5620a7182edcc$var$TokenSearch = class {
    static condition(_, options) {
        return options.useTokenSearch;
    }
    constructor(pattern, options){
        this.options = options;
        this.analyzer = $aef5620a7182edcc$var$createAnalyzer({
            isCaseSensitive: options.isCaseSensitive,
            ignoreDiacritics: options.ignoreDiacritics,
            tokenize: options.tokenize
        });
        const queryTerms = this.analyzer.tokenize(pattern);
        const { df: df, fieldCount: fieldCount } = options._invertedIndex;
        this.termSearchers = [];
        this.idfWeights = [];
        for (const term of queryTerms){
            this.termSearchers.push(new $aef5620a7182edcc$var$BitapSearch(term, {
                location: options.location,
                threshold: options.threshold,
                distance: options.distance,
                includeMatches: options.includeMatches,
                findAllMatches: options.findAllMatches,
                minMatchCharLength: options.minMatchCharLength,
                isCaseSensitive: options.isCaseSensitive,
                ignoreDiacritics: options.ignoreDiacritics,
                ignoreLocation: true
            }));
            const docFreq = df.get(term) || 0;
            const idf = Math.log(1 + (fieldCount - docFreq + .5) / (docFreq + .5));
            this.idfWeights.push(idf);
        }
        this.combineAll = options.tokenMatch === "all";
        this.numTerms = this.termSearchers.length;
        this.useMask = this.numTerms <= 31;
    }
    searchIn(text) {
        if (!this.termSearchers.length) return {
            isMatch: false,
            score: 1
        };
        const allIndices = [];
        let weightedScore = 0;
        let maxPossibleScore = 0;
        let matchedCount = 0;
        let matchedMask = 0;
        const matchedTerms = this.combineAll && !this.useMask ? /* @__PURE__ */ new Set() : null;
        for(let i = 0; i < this.termSearchers.length; i++){
            const result = this.termSearchers[i].searchIn(text);
            const idf = this.idfWeights[i];
            maxPossibleScore += idf;
            if (result.isMatch) {
                matchedCount++;
                weightedScore += idf * (1 - result.score);
                if (result.indices) allIndices.push(...result.indices);
                if (this.combineAll) {
                    if (this.useMask) matchedMask |= 1 << i;
                    else matchedTerms.add(i);
                }
            }
        }
        if (matchedCount === 0) return {
            isMatch: false,
            score: 1
        };
        const normalized = maxPossibleScore > 0 ? 1 - weightedScore / maxPossibleScore : 0;
        const searchResult = {
            isMatch: true,
            score: Math.max(.001, normalized)
        };
        if (this.options.includeMatches && allIndices.length) searchResult.indices = $aef5620a7182edcc$var$mergeIndices(allIndices);
        if (this.combineAll) {
            if (this.useMask) searchResult.matchedMask = matchedMask;
            else searchResult.matchedTerms = matchedTerms;
            searchResult.termCount = this.numTerms;
        }
        return searchResult;
    }
};
//#endregion
//#region src/search/token/InvertedIndex.ts
function $aef5620a7182edcc$var$addField(index, text, docIdx, analyzer) {
    const tokens = analyzer.tokenize(text);
    if (!tokens.length) return;
    index.fieldCount++;
    index.docFieldCount.set(docIdx, (index.docFieldCount.get(docIdx) || 0) + 1);
    const distinctTerms = new Set(tokens);
    let perDocTerms = index.docTermFieldHits.get(docIdx);
    if (!perDocTerms) {
        perDocTerms = /* @__PURE__ */ new Map();
        index.docTermFieldHits.set(docIdx, perDocTerms);
    }
    for (const term of distinctTerms){
        perDocTerms.set(term, (perDocTerms.get(term) || 0) + 1);
        index.df.set(term, (index.df.get(term) || 0) + 1);
    }
}
function $aef5620a7182edcc$var$ingestRecord(index, record, keyCount, analyzer) {
    const { i: docIdx, v: v, $: fields } = record;
    if (v !== void 0) {
        $aef5620a7182edcc$var$addField(index, v, docIdx, analyzer);
        return;
    }
    if (!fields) return;
    for(let keyIdx = 0; keyIdx < keyCount; keyIdx++){
        const value = fields[keyIdx];
        if (!value) continue;
        if (Array.isArray(value)) for (const sub of value)$aef5620a7182edcc$var$addField(index, sub.v, docIdx, analyzer);
        else $aef5620a7182edcc$var$addField(index, value.v, docIdx, analyzer);
    }
}
function $aef5620a7182edcc$var$buildInvertedIndex(records, keyCount, analyzer) {
    const index = {
        fieldCount: 0,
        df: /* @__PURE__ */ new Map(),
        docFieldCount: /* @__PURE__ */ new Map(),
        docTermFieldHits: /* @__PURE__ */ new Map()
    };
    for (const record of records)$aef5620a7182edcc$var$ingestRecord(index, record, keyCount, analyzer);
    return index;
}
function $aef5620a7182edcc$var$addToInvertedIndex(index, record, keyCount, analyzer) {
    $aef5620a7182edcc$var$ingestRecord(index, record, keyCount, analyzer);
}
function $aef5620a7182edcc$var$removeFromInvertedIndex(index, docIdx) {
    const fieldCount = index.docFieldCount.get(docIdx);
    if (fieldCount === void 0) return;
    index.fieldCount -= fieldCount;
    index.docFieldCount.delete(docIdx);
    const perDocTerms = index.docTermFieldHits.get(docIdx);
    if (!perDocTerms) return;
    for (const [term, hits] of perDocTerms){
        const next = (index.df.get(term) || 0) - hits;
        if (next <= 0) index.df.delete(term);
        else index.df.set(term, next);
    }
    index.docTermFieldHits.delete(docIdx);
}
function $aef5620a7182edcc$var$removeAndShiftInvertedIndex(index, removedIndices) {
    if (removedIndices.length === 0) return;
    const sorted = Array.from(new Set(removedIndices)).sort((a, b)=>a - b);
    for (const idx of sorted)$aef5620a7182edcc$var$removeFromInvertedIndex(index, idx);
    const shift = (oldIdx)=>{
        let lo = 0;
        let hi = sorted.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (sorted[mid] < oldIdx) lo = mid + 1;
            else hi = mid;
        }
        return oldIdx - lo;
    };
    const firstRemoved = sorted[0];
    const shiftedDocFieldCount = /* @__PURE__ */ new Map();
    for (const [oldKey, count] of index.docFieldCount)shiftedDocFieldCount.set(oldKey > firstRemoved ? shift(oldKey) : oldKey, count);
    index.docFieldCount = shiftedDocFieldCount;
    const shiftedDocTermFieldHits = /* @__PURE__ */ new Map();
    for (const [oldKey, terms] of index.docTermFieldHits)shiftedDocTermFieldHits.set(oldKey > firstRemoved ? shift(oldKey) : oldKey, terms);
    index.docTermFieldHits = shiftedDocTermFieldHits;
}
//#endregion
//#region src/core/index.ts
var $aef5620a7182edcc$var$Fuse = class {
    constructor(docs, options, index){
        this.options = {
            ...$aef5620a7182edcc$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this.options.useTokenSearch;
        this._keyStore = new $aef5620a7182edcc$var$KeyStore(this.options.keys);
        this._docs = docs;
        this._myIndex = null;
        this._invertedIndex = null;
        this.setCollection(docs, index);
        this._lastQuery = null;
        this._lastSearcher = null;
    }
    _getSearcher(query) {
        if (this._lastQuery === query) return this._lastSearcher;
        const searcher = $aef5620a7182edcc$var$createSearcher(query, this._invertedIndex ? {
            ...this.options,
            _invertedIndex: this._invertedIndex
        } : this.options);
        this._lastQuery = query;
        this._lastSearcher = searcher;
        return searcher;
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $aef5620a7182edcc$var$FuseIndex)) throw new Error($aef5620a7182edcc$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $aef5620a7182edcc$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
        if (this.options.useTokenSearch) {
            const analyzer = $aef5620a7182edcc$var$createAnalyzer({
                isCaseSensitive: this.options.isCaseSensitive,
                ignoreDiacritics: this.options.ignoreDiacritics,
                tokenize: this.options.tokenize
            });
            this._invertedIndex = $aef5620a7182edcc$var$buildInvertedIndex(this._myIndex.records, this._myIndex.keys.length, analyzer);
        }
        this._invalidateSearcherCache();
    }
    add(doc) {
        if (!$aef5620a7182edcc$var$isDefined(doc)) return;
        this._docs.push(doc);
        const record = this._myIndex.add(doc, this._docs.length - 1);
        if (this._invertedIndex && record) {
            const analyzer = $aef5620a7182edcc$var$createAnalyzer({
                isCaseSensitive: this.options.isCaseSensitive,
                ignoreDiacritics: this.options.ignoreDiacritics,
                tokenize: this.options.tokenize
            });
            $aef5620a7182edcc$var$addToInvertedIndex(this._invertedIndex, record, this._myIndex.keys.length, analyzer);
        }
        this._invalidateSearcherCache();
    }
    remove(predicate = ()=>false) {
        const results = [];
        const indicesToRemove = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1)if (predicate(this._docs[i], i)) {
            results.push(this._docs[i]);
            indicesToRemove.push(i);
        }
        if (indicesToRemove.length) {
            if (this._invertedIndex) $aef5620a7182edcc$var$removeAndShiftInvertedIndex(this._invertedIndex, indicesToRemove);
            const toRemove = new Set(indicesToRemove);
            this._docs = this._docs.filter((_, i)=>!toRemove.has(i));
            this._myIndex.removeAll(indicesToRemove);
            this._invalidateSearcherCache();
        }
        return results;
    }
    removeAt(idx) {
        if (!Number.isInteger(idx) || idx < 0 || idx >= this._docs.length) throw new Error($aef5620a7182edcc$var$INVALID_DOC_INDEX);
        if (this._invertedIndex) $aef5620a7182edcc$var$removeAndShiftInvertedIndex(this._invertedIndex, [
            idx
        ]);
        const doc = this._docs.splice(idx, 1)[0];
        this._myIndex.removeAt(idx);
        this._invalidateSearcherCache();
        return doc;
    }
    _invalidateSearcherCache() {
        this._lastQuery = null;
        this._lastSearcher = null;
    }
    getIndex() {
        return this._myIndex;
    }
    _normalizedKeys() {
        return this._myIndex.keys.map((key)=>this._keyStore.get(key.id) || key);
    }
    search(query, options) {
        const { limit: limit = -1 } = options || {};
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        if ($aef5620a7182edcc$var$isString(query) && !query.trim()) {
            let docs = this._docs.map((item, idx)=>({
                    item: item,
                    refIndex: idx
                }));
            if ($aef5620a7182edcc$var$isNumber(limit) && limit > -1) docs = docs.slice(0, limit);
            return docs;
        }
        const useHeap = shouldSort && $aef5620a7182edcc$var$isNumber(limit) && limit > 0 && $aef5620a7182edcc$var$isString(query);
        const comparator = sortFn;
        const stable = (a, b)=>comparator(a, b) || a.idx - b.idx;
        let results;
        if (useHeap) {
            const heap = new $aef5620a7182edcc$var$MaxHeap(limit, stable);
            if ($aef5620a7182edcc$var$isString(this._docs[0])) this._searchStringList(query, {
                heap: heap,
                ignoreFieldNorm: ignoreFieldNorm
            });
            else this._searchObjectList(query, {
                heap: heap,
                ignoreFieldNorm: ignoreFieldNorm
            });
            results = heap.extractSorted();
        } else {
            results = $aef5620a7182edcc$var$isString(query) ? $aef5620a7182edcc$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
            $aef5620a7182edcc$var$computeScore(results, {
                ignoreFieldNorm: ignoreFieldNorm
            });
            if (shouldSort) results.sort($aef5620a7182edcc$var$isString(query) ? stable : comparator);
            if ($aef5620a7182edcc$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        }
        return $aef5620a7182edcc$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query, { heap: heap, ignoreFieldNorm: ignoreFieldNorm } = {}) {
        const searcher = this._getSearcher(query);
        const requireAllTokens = this.options.useTokenSearch && this.options.tokenMatch === "all";
        const { records: records } = this._myIndex;
        const results = heap ? null : [];
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$aef5620a7182edcc$var$isDefined(text)) return;
            const searchResult = searcher.searchIn(text);
            if (searchResult.isMatch) {
                const match = {
                    score: searchResult.score,
                    value: text,
                    norm: norm,
                    indices: searchResult.indices
                };
                if (requireAllTokens) {
                    match.matchedMask = searchResult.matchedMask;
                    match.matchedTerms = searchResult.matchedTerms;
                    match.termCount = searchResult.termCount;
                }
                const matches = [
                    match
                ];
                if (!requireAllTokens || this._coversAllTokens(matches)) {
                    const result = {
                        item: text,
                        idx: idx,
                        matches: matches
                    };
                    if (heap) {
                        result.score = $aef5620a7182edcc$var$computeScoreSingle(result.matches, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        heap.insert(result);
                    } else results.push(result);
                }
            }
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $aef5620a7182edcc$var$parse(query, this.options);
        const keys = this._normalizedKeys();
        const evaluate = (node, item, idx)=>{
            if (!("children" in node)) {
                const { keyId: keyId, searcher: searcher } = node;
                let matches;
                if (keyId === null) {
                    matches = [];
                    keys.forEach((key, keyIndex)=>{
                        matches.push(...this._findMatches({
                            key: key,
                            value: item[keyIndex],
                            searcher: searcher
                        }));
                    });
                } else matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const { children: children, operator: operator } = node;
            const res = [];
            for(let i = 0, len = children.length; i < len; i += 1){
                const child = children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (operator === $aef5620a7182edcc$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = /* @__PURE__ */ new Map();
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($aef5620a7182edcc$var$isDefined(item)) {
                const expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    if (!resultMap.has(idx)) {
                        resultMap.set(idx, {
                            idx: idx,
                            item: item,
                            matches: []
                        });
                        results.push(resultMap.get(idx));
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap.get(idx).matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query, { heap: heap, ignoreFieldNorm: ignoreFieldNorm } = {}) {
        const searcher = this._getSearcher(query);
        const requireAllTokens = this.options.useTokenSearch && this.options.tokenMatch === "all";
        const { records: records } = this._myIndex;
        const keys = this._normalizedKeys();
        const results = heap ? null : [];
        records.forEach(({ $: item, i: idx })=>{
            if (!$aef5620a7182edcc$var$isDefined(item)) return;
            const matches = [];
            let anyKeyFailed = false;
            let hasInverse = false;
            keys.forEach((key, keyIndex)=>{
                const keyMatches = this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                });
                if (keyMatches.length) {
                    matches.push(...keyMatches);
                    if (keyMatches[0].hasInverse) hasInverse = true;
                } else anyKeyFailed = true;
            });
            if (hasInverse && anyKeyFailed) return;
            if (matches.length && (!requireAllTokens || this._coversAllTokens(matches))) {
                const result = {
                    idx: idx,
                    item: item,
                    matches: matches
                };
                if (heap) {
                    result.score = $aef5620a7182edcc$var$computeScoreSingle(result.matches, {
                        ignoreFieldNorm: ignoreFieldNorm
                    });
                    heap.insert(result);
                } else results.push(result);
            }
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$aef5620a7182edcc$var$isDefined(value)) return [];
        const matches = [];
        if ($aef5620a7182edcc$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$aef5620a7182edcc$var$isDefined(text)) return;
            const searchResult = searcher.searchIn(text);
            if (searchResult.isMatch) {
                const match = {
                    score: searchResult.score,
                    key: key,
                    value: text,
                    idx: idx,
                    norm: norm,
                    indices: searchResult.indices,
                    hasInverse: searchResult.hasInverse
                };
                if (searchResult.termCount !== void 0) {
                    match.matchedMask = searchResult.matchedMask;
                    match.matchedTerms = searchResult.matchedTerms;
                    match.termCount = searchResult.termCount;
                }
                matches.push(match);
            }
        });
        else {
            const { v: text, n: norm } = value;
            const searchResult = searcher.searchIn(text);
            if (searchResult.isMatch) {
                const match = {
                    score: searchResult.score,
                    key: key,
                    value: text,
                    norm: norm,
                    indices: searchResult.indices,
                    hasInverse: searchResult.hasInverse
                };
                if (searchResult.termCount !== void 0) {
                    match.matchedMask = searchResult.matchedMask;
                    match.matchedTerms = searchResult.matchedTerms;
                    match.termCount = searchResult.termCount;
                }
                matches.push(match);
            }
        }
        return matches;
    }
    _coversAllTokens(matches) {
        const termCount = matches.length ? matches[0].termCount : void 0;
        if (termCount === void 0) return true;
        if (termCount <= 31) {
            let coverage = 0;
            for(let i = 0; i < matches.length; i++)coverage |= matches[i].matchedMask || 0;
            return coverage === 2 ** termCount - 1;
        }
        const coverage = /* @__PURE__ */ new Set();
        for(let i = 0; i < matches.length; i++){
            const terms = matches[i].matchedTerms;
            if (terms) for (const t of terms)coverage.add(t);
        }
        return coverage.size === termCount;
    }
};
//#endregion
//#region src/entry.ts
$aef5620a7182edcc$var$Fuse.version = "7.5.0";
$aef5620a7182edcc$var$Fuse.createIndex = $aef5620a7182edcc$var$createIndex;
$aef5620a7182edcc$var$Fuse.parseIndex = $aef5620a7182edcc$var$parseIndex;
$aef5620a7182edcc$var$Fuse.config = $aef5620a7182edcc$var$Config;
$aef5620a7182edcc$var$Fuse.match = function(pattern, text, options) {
    if (options && options.useTokenSearch) throw new Error($aef5620a7182edcc$var$FUSE_MATCH_TOKEN_SEARCH_UNSUPPORTED);
    return $aef5620a7182edcc$var$createSearcher(pattern, {
        ...$aef5620a7182edcc$var$Config,
        ...options
    }).searchIn(text);
};
$aef5620a7182edcc$var$Fuse.parseQuery = $aef5620a7182edcc$var$parse;
$aef5620a7182edcc$var$register($aef5620a7182edcc$var$ExtendedSearch);
$aef5620a7182edcc$var$register($aef5620a7182edcc$var$TokenSearch);
$aef5620a7182edcc$var$Fuse.use = function(...plugins) {
    plugins.forEach((plugin)=>$aef5620a7182edcc$var$register(plugin));
};
var $aef5620a7182edcc$export$2e2bcd8739ae039 = $aef5620a7182edcc$var$Fuse;


/**
 * @description Alpine directives
 */ 
/**
 * @param {HTMLElement} el
 * @param {string} expression
 * @param {string[]} modifiers
 * @returns {void}
 */ (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).directive("money", (el, { expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, effect: effect })=>{
    const raw = modifiers.includes("raw");
    const value = evaluateLater(expression);
    effect(()=>{
        value((value)=>{
            el.innerText = Shopify.helpers.asMoney(raw ? value : value / 100);
        });
    });
});


/**
 * @description Alpine magics
 */ 
/**
 * Dispatches a custom event with the given name and detail.
 *
 * This overrides the `dispatch` magic function from Alpine, but keeps the same API.
 *
 * @param {Element} el - The element to dispatch the event on. If `window` is true, this will be `window`.
 * @param {string} name - The name of the event.
 * @param {Object} [detail={}] - The detail object for the event.
 * @param {boolean} [dispatchOnWindow=false] - Whether to dispatch the event on `window` instead of `el`.
 * 
 * @returns {void}
 */ let $c27b3b3964b6ffba$var$dispatch = function(el, name, detail = {}, dispatchOnWindow = false) {
    if (dispatchOnWindow) el = window;
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
};
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).magic('dispatch', (el)=>$c27b3b3964b6ffba$var$dispatch.bind($c27b3b3964b6ffba$var$dispatch, el));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('liveSearch', ()=>({
        query: '',
        searching: false,
        results: {
            products: [],
            queries: []
        },
        events: {
            form: {
                ['x-on:click.away'] () {
                    this.reset();
                },
                ['x-on:keydown.escape'] () {
                    this.reset();
                },
                ['x-on:live-search:reset.window'] () {
                    this.reset();
                }
            },
            input: {
                ['x-on:focus'] () {
                    this.fetchResults();
                },
                ['x-on:click'] () {
                    this.fetchResults();
                }
            }
        },
        init () {
            this.$watch('query', (value)=>{
                this.fetchResults();
            });
        },
        get popupVisible () {
            return this.results?.products.length > 0 || this.results?.queries.length > 0;
        },
        reset () {
            this.results.products = [];
            this.results.queries = [];
            this.searching = false;
        },
        fetchResults () {
            if (this.query.length > 0) this.searching = true;
            this.results.products = [];
            this.results.queries = [];
            fetch(window.Shopify.routes.root + `search/suggest.json?q=${this.query}&resources[type]=query,product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`).then((response)=>response.json()).then((suggestions)=>{
                this.results.products = suggestions.resources.results.products;
                this.results.queries = suggestions.resources.results.queries;
            }).finally(()=>{
                this.searching = false;
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('navItem', ()=>({
        events: {
            ['x-on:mouseenter'] () {
                this.$dispatch('live-search:reset');
                this.$dispatch('header:pin');
                this.$dispatch('header:block');
            },
            ['x-on:mouseleave'] () {
                this.$dispatch('header:unpin');
                this.$dispatch('header:unblock');
            }
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('header', ()=>({
        scrolled: false,
        pinned: false,
        blocked: false,
        //ew
        hasHero: false,
        init () {
            this.hasHero = document.querySelector('main:has(.grid-template-hero)');
            if (!this.hasHero) this.pinned = true;
            this.scrolled = window.scrollY > 0;
        },
        events: {
            ['x-on:header:pin'] () {
                this.pinned = true;
            },
            // Blurring the nav requests unpinning, so we only unpin if we have a hero
            ['x-on:header:unpin'] () {
                if (!this.hasHero) return;
                this.pinned = false;
            },
            ['x-on:header:block'] () {
                this.blocked = true;
            },
            ['x-on:header:unblock'] () {
                this.blocked = false;
            },
            // scroll to top requests unpinning, so we only unpin if we have a hero
            ['x-on:scroll.window'] () {
                if (!this.hasHero) return;
                this.scrolled = window.scrollY > 0;
            }
        },
        get classList () {
            return {
                'is-opaque': this.scrolled || this.pinned,
                'is-transparent': !this.scrolled && !this.pinned,
                'after:bg-black/50': this.blocked
            };
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('minicart', ()=>({
        events: {
            ['x-on:keydown.escape.window.prevent'] () {
                this.close();
            }
        },
        get cart () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('cart');
        },
        get items () {
            return this.cart.items || [];
        },
        get total () {
            return this.cart.total_price || 0;
        },
        open () {
            this.$root.showModal();
        },
        close () {
            this.$root.close();
        },
        updateItemInCart (key, quantity) {
            this.items = this.items.map((item)=>{
                item.working = item.key === key;
                return item;
            });
            Shopify.cart.update(key, quantity).catch((error)=>{
                this.$dispatch('toast:show', {
                    message: error.message,
                    timeout: 2000,
                    type: 'error'
                }, true);
            });
        },
        removeItemFromCart (key) {
            let removedItem = this.items.find((item)=>item.key === key);
            this.items = this.items.map((item)=>{
                item.working = item.key === key;
                return item;
            });
            Shopify.cart.update(key, 0).then(()=>{
                this.$dispatch('toast:show', {
                    message: `${removedItem.title} removed from cart.`,
                    timeout: 2000,
                    type: 'success'
                }, true);
                if (this.items.length === 0) this.close();
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('minicartItem', (key)=>({
        working: false,
        key: key,
        get cart () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('cart');
        },
        get item () {
            return this.cart.items.find((item)=>item.key === this.key);
        },
        remove () {
            this.working = true;
            let title = this.item.title;
            Shopify.cart.remove(this.key).then((cart)=>{
                this.$dispatch('toast:show', {
                    type: 'success',
                    message: `${title} has been removed from your cart.`
                }, true);
            }).catch((error)=>{
                this.$dispatch('toast:show', {
                    type: 'error',
                    message: `There was an error removing ${title} from your cart. Please try again.`
                }, true);
            }).finally(()=>{
                this.working = false;
            });
        },
        update (quantity) {
            this.working = true;
            let title = this.item.title;
            Shopify.cart.change(this.key, quantity).catch((error)=>{
                this.$dispatch('toast:show', {
                    type: 'error',
                    message: `There was an error updating ${title} in your cart. Please try again.`
                }, true);
            }).finally(()=>{
                this.working = false;
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("addedToCartModal", ()=>({
        productName: undefined,
        productOptions: undefined,
        productPrice: undefined,
        events: {
            ["x-on:keydown.escape.window.prevent"] () {
                this.hide();
            },
            ["x-on:added-to-cart-modal:show.window"] (event) {
                this.show(event.detail.productName, event.detail.productOptions, event.detail.productPrice);
            }
        },
        show (productName, productOptions, productPrice) {
            this.productName = productName;
            this.productOptions = productOptions;
            this.productPrice = productPrice;
            this.$root.showModal();
        },
        hide () {
            this.$root.close();
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("carousel", (id, autoScrollInterval = null)=>{
    return {
        id: id,
        autoScrollInterval: autoScrollInterval,
        autoScrollTimer: null,
        get container () {
            return this.$el;
        },
        init () {
            this.setupEventListeners();
            if (this.autoScrollInterval && this.container.children.length > 0) this.setupAutoScroll();
        },
        setupAutoScroll () {
            this.startAutoScroll();
            this.container.addEventListener("scroll", ()=>{
                this.stopAutoScroll();
                this.startAutoScroll();
            });
        },
        setupEventListeners () {
            window.addEventListener(`scroll-carousel:${this.id}:next`, ()=>{
                this.scrollNext();
            });
            window.addEventListener(`scroll-carousel:${this.id}:previous`, ()=>{
                this.scrollPrevious();
            });
            window.addEventListener(`scroll-carousel:${this.id}:start`, ()=>{
                this.scrollTo(0);
            });
            window.addEventListener(`scroll-carousel:${this.id}:to`, (event)=>{
                this.scrollTo(event.detail.index);
            });
        },
        scrollNext () {
            const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = this.container;
            const isAtEnd = scrollLeft + offsetWidth >= scrollWidth - 10;
            this.container._scrollBy({
                left: isAtEnd ? -this.container.scrollLeft : this.container.offsetWidth,
                behavior: "smooth"
            });
        },
        scrollPrevious () {
            this.container._scrollBy({
                left: -this.container.offsetWidth,
                behavior: "smooth"
            });
        },
        scrollTo (index) {
            const child = this.container.children[index];
            if (child) this.container.scrollTo({
                left: index === 0 ? 0 : this.container.scrollLeft + (child.getBoundingClientRect().left - this.container.getBoundingClientRect().left),
                behavior: 'smooth'
            });
        },
        startAutoScroll () {
            this.autoScrollTimer = setInterval(()=>{
                this.scrollNext();
            }, this.autoScrollInterval);
        },
        stopAutoScroll () {
            if (this.autoScrollTimer) {
                clearInterval(this.autoScrollTimer);
                this.autoScrollTimer = null;
            }
        }
    };
});



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('carouselPagination', (id)=>{
    return {
        id: id,
        visibleItems: [],
        get carousel () {
            return document.querySelector(`[x-data="carousel('${this.id}')"]`);
        },
        init () {
            window.addEventListener(`carousel:${this.id}:item-enter`, (event)=>{
                const index = event.detail.index;
                if (!this.visibleItems.includes(index)) {
                    this.visibleItems.push(index);
                    this.visibleItems.sort((a, b)=>a - b);
                }
            });
            window.addEventListener(`carousel:${this.id}:item-leave`, (event)=>{
                const index = event.detail.index;
                this.visibleItems = this.visibleItems.filter((i)=>i !== index);
            });
        }
    };
});



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("carouselButtons", (id)=>{
    return {
        id: id,
        firstLastVisibility: {
            first: false,
            last: false
        },
        get carousel () {
            return document.querySelector(`[x-data="carousel('${this.id}')"]`);
        },
        get canGoPrevious () {
            return !this.firstLastVisibility.first;
        },
        get canGoNext () {
            return !this.firstLastVisibility.last;
        },
        get atStart () {
            return this.firstLastVisibility.first;
        },
        get atEnd () {
            return this.firstLastVisibility.last;
        },
        init () {
            window.addEventListener(`carousel:${this.id}:item-enter`, (event)=>{
                const index = event.detail.index;
                if (index === 0) this.firstLastVisibility.first = true;
                if (index === this.carousel.children.length - 1) this.firstLastVisibility.last = true;
            });
            window.addEventListener(`carousel:${this.id}:item-leave`, (event)=>{
                const index = event.detail.index;
                if (index === 0) this.firstLastVisibility.first = false;
                if (index === this.carousel.children.length - 1) this.firstLastVisibility.last = false;
            });
        }
    };
});




(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("resourceCentre", (currentCompanyId)=>({
        query: "",
        loading: false,
        grouped: true,
        _resources: [],
        currentCompanyId: currentCompanyId,
        get accordionItems () {
            return this.$root.querySelectorAll("details");
        },
        get resources () {
            return Object.keys(this._resources).reduce((accumulator, key)=>{
                let resources = this._resources[key].all;
                // Apply search filter if query is not empty
                if (this.query.trim() !== "") {
                    const fuseResults = this._resources[key].fuse.search(this.query);
                    resources = fuseResults.map((result)=>result.item);
                    // When searching, expand all accordion items and disable grouping
                    this.$nextTick(()=>{
                        this.grouped = false;
                        this.accordionItems.forEach((item)=>{
                            item.open = true;
                        });
                    });
                } else // When not searching, collapse all accordion items except the first and enable grouping
                this.$nextTick(()=>{
                    this.grouped = true;
                });
                if (resources.length > 0) accumulator[key] = resources;
                return accumulator;
            }, {});
        },
        parseArrayValue (value) {
            if (Array.isArray(value)) return value;
            if (typeof value === "string") try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [];
            } catch  {
                return [];
            }
            return [];
        },
        init () {
            this.loading = true;
            this.getAllResources().then(()=>{
                // map API resources into the structure consumed by the template
                this._resources = this._resources.map((resource)=>{
                    return {
                        file: resource.file || null,
                        title: resource.title || "",
                        type: this.parseArrayValue(resource.type),
                        customers: this.parseArrayValue(resource.customer_visibility)
                    };
                });
                this._resources = this._resources.filter((resource)=>{
                    if (this.currentCompanyId) // If there's a company, only show resources that are either public (i.e. with no customer visibility) or assigned to the current company
                    return resource.customers.length === 0 || resource.customers.includes(`gid://shopify/Company/${this.currentCompanyId}`);
                    // Without a company, only show public resources.
                    return resource.customers.length === 0;
                });
                // group resources by "type"
                this._resources = this._resources.reduce((accumulator, resource)=>{
                    let types = resource.type || [];
                    types.forEach((type)=>{
                        if (!accumulator[type]) accumulator[type] = [];
                        accumulator[type].push(resource);
                    });
                    return accumulator;
                }, {});
                // setup fuse
                Object.keys(this._resources).forEach((key)=>{
                    this._resources[key] = {
                        all: this._resources[key],
                        fuse: new (0, $aef5620a7182edcc$export$2e2bcd8739ae039)(this._resources[key], {
                            keys: [
                                "title",
                                "type"
                            ],
                            threshold: 0.3
                        })
                    };
                });
                // check for query param
                const urlParams = new URLSearchParams(window.location.search);
                const queryParam = urlParams.get("q");
                if (queryParam) this.query = queryParam;
                this.loading = false;
            });
        },
        async getAllResources () {
            try {
                const apiUrl = new URL("https://shopify-api.clearwebserver.co.uk/rozone/");
                if (this.currentCompanyId) apiUrl.searchParams.set("company", String(this.currentCompanyId));
                const response = await fetch(apiUrl.toString());
                if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
                const data = await response.json();
                this._resources = Array.isArray(data) ? data : [];
            } catch (error) {
                console.error("Error fetching resources:", error);
                this._resources = [];
            }
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("productResources", (currentCompanyId, productId)=>({
        loading: false,
        resources: [],
        currentCompanyId: currentCompanyId,
        productId: productId,
        init () {
            if (!this.productId) return;
            this.loading = true;
            this.getResources().finally(()=>{
                this.loading = false;
            });
        },
        normalizeResource (resource) {
            return {
                title: resource?.title || "",
                file: resource?.file || resource?.file_upload?.value?.url || null
            };
        },
        async getResources () {
            try {
                const apiUrl = new URL("https://shopify-api.clearwebserver.co.uk/rozone/");
                apiUrl.searchParams.set("product", String(this.productId));
                if (this.currentCompanyId) apiUrl.searchParams.set("company", String(this.currentCompanyId));
                const response = await fetch(apiUrl.toString());
                if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
                const data = await response.json();
                this.resources = (Array.isArray(data) ? data : []).map((resource)=>this.normalizeResource(resource)).filter((resource)=>resource.title && resource.file);
            } catch (error) {
                console.error("Error fetching product resources:", error);
                this.resources = [];
            }
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('priceRangeFilter', (paramName, min, max)=>({
        paramName: paramName,
        min: min,
        max: max,
        isActive: false,
        init () {
            const currentValue = this.getCurrentValue();
            if (!currentValue) return;
            if (currentValue) {
                if (currentValue.min === this.min && currentValue.max === this.max) this.isActive = true;
            }
        },
        getCurrentValue () {
            const urlParams = new URLSearchParams(window.location.search);
            const currentMin = urlParams.get(`${this.paramName}.gte`);
            const currentMax = urlParams.get(`${this.paramName}.lte`);
            if (!currentMin || !currentMax) return null;
            return {
                min: parseFloat(currentMin),
                max: parseFloat(currentMax)
            };
        },
        get urlToAdd () {
            const url = new URL(window.location.href);
            url.searchParams.set(`${this.paramName}.gte`, this.min);
            url.searchParams.set(`${this.paramName}.lte`, this.max);
            return url.toString();
        },
        get urlToRemove () {
            const url = new URL(window.location.href);
            url.searchParams.delete(`${this.paramName}.gte`);
            url.searchParams.delete(`${this.paramName}.lte`);
            return url.toString();
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('priceRangeActiveFilters', ()=>({
        priceFilters: [],
        get hasPriceFilters () {
            return this.priceFilters.length > 0;
        },
        init () {
            const currentUrl = new URL(window.location.href);
            for (const [key, value] of currentUrl.searchParams.entries()){
                let match = key.match(/^(.+)\.(gte|lte)$/);
                if (match) {
                    let priceFilterBaseParamName = match[1];
                    if (!this.priceFilters.some((filter)=>filter.name === priceFilterBaseParamName)) {
                        let label = priceFilterBaseParamName.replace('filter.v.', '');
                        let gte = window.Shopify.helpers.asMoney(parseFloat(currentUrl.searchParams.get(`${priceFilterBaseParamName}.gte`)));
                        let lte = window.Shopify.helpers.asMoney(parseFloat(currentUrl.searchParams.get(`${priceFilterBaseParamName}.lte`)));
                        let removeFilterUrl = new URL(window.location.href);
                        removeFilterUrl.searchParams.delete(`${priceFilterBaseParamName}.gte`);
                        removeFilterUrl.searchParams.delete(`${priceFilterBaseParamName}.lte`);
                        this.priceFilters.push({
                            name: priceFilterBaseParamName,
                            label: `${label} (${gte} - ${lte})`,
                            removeUrl: removeFilterUrl.toString()
                        });
                    }
                }
            }
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('mobileFilters', ()=>({
        events: {
            ['x-on:keydown.escape.window.prevent'] () {
                this.close();
            },
            ['x-on:mobile-filters:open.window'] () {
                this.open();
            },
            ['x-on:mobile-filters:close.window'] () {
                this.close();
            }
        },
        open () {
            this.$root.showModal();
        },
        close () {
            this.$root.close();
        },
        submit () {
            const data = new FormData(this.$event.target);
            const value = Object.fromEntries(data.entries());
            // find "filter.v.price", get its value (should be like "10-50"), split on "-", convert to min and max and update filter.v.price.gte and filter.v.price.lte
            if (value['filter.v.price']) {
                const [min, max] = value['filter.v.price'].split('-');
                value['filter.v.price.gte'] = min;
                value['filter.v.price.lte'] = max;
                delete value['filter.v.price'];
            }
            window.location.href = `${window.location.pathname}?${new URLSearchParams(value).toString()}`;
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("sortByFilter", (sortOptions)=>({
        sortOptions: sortOptions,
        init () {
            const currentSortBy = new URL(window.location.href).searchParams.get("sort_by");
            this.sortOptions = this.sortOptions.map((option)=>({
                    value: option[0],
                    name: option[1],
                    active: option[0] === currentSortBy
                }));
        },
        getSortOptionUrl (sortOption) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('sort_by', sortOption.value);
            return currentUrl.toString();
        },
        get currentSortOptionName () {
            const activeOption = this.sortOptions.find((option)=>option.active);
            return activeOption ? activeOption.name : 'Sort By';
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('clearFiltersButton', ()=>({
        get url () {
            const params = new URLSearchParams(window.location.search);
            const query = params.get('q');
            return query ? `${window.location.pathname}?q=${query}` : window.location.pathname;
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('gallery', (media)=>({
        media: media,
        get hasTrack () {
            return this.media.length > 1;
        },
        init () {
            this.media = this.media.sort((a, b)=>a.position - b.position).map((item, index)=>{
                item.active = index === 0;
                item.src.src = `${item.preview_image.src}&width=800`;
                item.poster = `${item.preview_image.src}&width=800`;
                item.preview_image.src = `${item.preview_image.src}&width=200`;
                return item;
            });
        },
        setActiveFromVariant () {
            let variant = this.$event.detail;
            this.setActive(this.media.findIndex((item)=>item.id === variant.featured_media.id));
        },
        setActive (activeIndex) {
            this.media = this.media.map((item, index)=>{
                item.active = index === activeIndex;
                return item;
            });
            if (activeIndex === 0) {
                this.$refs.track.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
                return;
            }
            this.$refs.track.children[activeIndex].scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });
        },
        close () {
            this.$root.close();
        },
        previousImage () {
            let currentIndex = this.media.findIndex((item)=>item.active);
            let previousIndex = (currentIndex - 1 + this.media.length) % this.media.length;
            this.setActive(previousIndex);
        },
        nextImage () {
            let currentIndex = this.media.findIndex((item)=>item.active);
            let nextIndex = (currentIndex + 1) % this.media.length;
            this.setActive(nextIndex);
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("solutionFinder", (collectionUrl)=>({
        isStarted: false,
        productType: '',
        contamination: '',
        material: '',
        collectionUrl: collectionUrl || window.location.pathname,
        product_types: {},
        target_contaminants: {},
        target_materials: {},
        start () {
            fetch("https://rozone-01.myshopify.com/api/2026-04/graphql.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": "ceb861b316aa8a52eebe7f3b0e6c8736"
                },
                body: JSON.stringify({
                    query: `
          {
            collection(handle: "solution-finder") {
              handle
              products(first: 250) {
                filters {
                  id
                  label
                  values {
                    label
                    count
                  }
                }
              }
            }
          }
        `
                })
            }).then((response)=>response.json()).then((data)=>{
                for (let product of data.data.collection.products.filters)switch(product.id){
                    case "filter.p.product_type":
                        this.product_types = product.values;
                        break;
                    case "filter.p.m.custom.target_contaminants":
                        this.target_contaminants = product.values;
                        break;
                    case "filter.p.m.custom.target_materials":
                        this.target_materials = product.values;
                        break;
                }
            }).catch((error)=>console.error(error));
            this.isStarted = true;
        },
        submit () {
            const url = new URL(this.collectionUrl, window.location.origin);
            url.searchParams.delete('filter.p.product_type');
            url.searchParams.delete('filter.p.m.custom.target_contaminants');
            url.searchParams.delete('filter.p.m.custom.target_materials');
            if (this.productType) url.searchParams.append('filter.p.product_type', this.productType);
            if (this.contamination) url.searchParams.append('filter.p.m.custom.target_contaminants', this.contamination);
            if (this.material) url.searchParams.append('filter.p.m.custom.target_materials', this.material);
            window.location.href = url.toString();
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('toast', ()=>({
        message: '',
        timeout: null,
        type: 'info',
        get classList () {
            return {
                'bg-green-500 text-white': this.type === 'success',
                'bg-red-500 text-white': this.type === 'error',
                'bg-blue-500 text-white': this.type === 'info'
            };
        },
        events: {
            ['x-on:click'] () {
                this.close();
            },
            ['x-on:keydown.escape.window'] () {
                this.close();
            },
            ['x-on:toast:show.window'] (event) {
                const { message: message, duration: duration, type: type } = event.detail;
                this.show(message, duration, type);
            }
        },
        close () {
            this.$root.close();
        },
        show (message, duration = 3000, type = 'info') {
            this.message = message;
            this.type = type;
            this.$root.showModal();
            clearTimeout(this.timeout);
            this.timeout = setTimeout(()=>{
                this.close();
            }, duration);
        }
    }));




(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("addToCartForm", ()=>({
        working: false,
        events: {
            ["x-on:cart:added.window"] () {
                this.working = false;
            },
            ["x-on:cart:adding.window"] () {
                this.working = true;
            },
            ["x-on:submit.prevent"] () {
                this.addToCart();
            }
        },
        get canAddToCart () {
            return this.variant.available;
        },
        get variant () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store("variant");
        },
        get product () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store("product");
        },
        addToCart () {
            let formData = new FormData(this.$root);
            let quantity = formData.get("quantity");
            Shopify.cart.add(parseInt(this.variant.id), parseInt(quantity || 1)).then((e)=>{
                this.$dispatch("added-to-cart-modal:show", {
                    productName: this.product.title,
                    productOptions: this.variant.title === "Default Title" ? null : this.variant.title,
                    productPrice: this.variant.price * quantity
                });
            }).catch((error)=>{
                this.$dispatch("toast:show", {
                    message: error.message,
                    type: "error"
                }, true);
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("quantitySelector", ()=>({
        get variant () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store("variant");
        },
        get min () {
            let _min = this.variant.stock?.inventory_management === "shopify" ? this.variant.quantity_rule?.min : 1;
            return _min || 1;
        },
        get max () {
            let _max = this.variant.stock?.inventory_management === "shopify" ? this.variant.quantity_rule?.max : 9999;
            return _max || 9999;
        },
        get increment () {
            return this.variant.quantity_rule?.increment || 1;
        },
        quantity: 1,
        incrementQuantity () {
            if (this.quantity < this.max) this.quantity += this.increment;
        },
        decrementQuantity () {
            if (this.quantity > this.min) this.quantity -= this.increment;
        },
        get totalPrice () {
            return this.variant.price * this.quantity;
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('variantSelector', ()=>({
        selectedOptions: (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('variant').options,
        get product () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('product');
        },
        get variant () {
            return (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('variant');
        },
        get variants () {
            return this.product.variants;
        },
        isOptionInStock (optionIndex, optionValue) {
            let currentlySelectedOptions = [
                ...this.selectedOptions
            ];
            currentlySelectedOptions[optionIndex] = optionValue;
            return this.variants.some((variant)=>currentlySelectedOptions.every((option, i)=>variant.options[i] === option) && variant.stock.available);
        },
        init () {
            this.$nextTick(()=>{
                this.selectedOptions = [
                    ...this.variant.options
                ];
            });
            this.$watch('selectedOptions', (options)=>{
                (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('variant', this.variants.find((variant)=>options.every((option, i)=>variant.options[i] === option)));
                this.$dispatch('variant-selector:change', (0, $99b18dd98d1424fc$export$2e2bcd8739ae039).store('variant'));
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('shippingCalculator', (availableCountries)=>({
        working: false,
        zip: '',
        country: '',
        province: '',
        rates: [],
        availableCountries: availableCountries,
        getShippingRates () {
            this.working = true;
            this.rates = [];
            Shopify.cart.prepareShippingRates(this.zip, this.country, this.province).then(()=>{
                const fetchRates = ()=>{
                    Shopify.cart.asyncShippingRates(this.zip, this.country, this.province).then((rates)=>{
                        if (rates.shipping_rates) {
                            this.rates = rates.shipping_rates;
                            return;
                        }
                        fetchRates();
                    });
                };
                fetchRates();
            }).catch((error)=>{
                this.$dispatch('toast:show', {
                    message: error.message,
                    timeout: 2000,
                    type: 'error'
                }, true);
            }).finally(()=>{
                this.working = false;
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('cart', ()=>({
        working: false,
        events: {
            ['x-on:cart:changing.window'] () {
                this.working = true;
            },
            ['x-on:cart:refreshing.window'] () {
                this.working = true;
            },
            ['x-on:cart:refreshed.window'] () {
                this.working = false;
            }
        },
        get cart () {
            return this.$store.cart;
        },
        get isEmpty () {
            return this.cart.items.length === 0;
        },
        async decrement (item) {
            await Shopify.cart.change(item.key, item.quantity - 1);
        },
        async increment (item) {
            await Shopify.cart.change(item.key, item.quantity + 1).catch((error)=>{
                this.$dispatch('toast:show', {
                    message: error.message,
                    timeout: 2000,
                    type: 'error'
                }, true);
            });
        },
        async updateQuantity (item, event) {
            let value = parseInt(event.target.value);
            if (isNaN(value)) event.target.value = item.quantity;
            await Shopify.cart.change(item.key, value);
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('mobileNavigation', ()=>({
        level: 0,
        get style () {
            return `--left: -${this.level * 100}%`;
        },
        events: {
            ['x-intersect:leave.full'] () {
                this.level = 0;
            },
            ['x-on:keydown.escape.window.prevent'] () {
                this.goBackOrClose();
            }
        },
        open () {
            this.$root.showModal();
        },
        close () {
            this.$root.close();
        },
        goBackOrClose () {
            if (this.level === 0) this.close();
            else this.decrementLevel();
        },
        incrementLevel (e) {
            e.target.closest('li').querySelector('ul').classList.remove('hidden');
            this.level++;
        },
        decrementLevel (e) {
            this.level = Math.max(0, this.level - 1);
            Shopify.helpers.wait(300).then(()=>{
                e.target.closest('ul').classList.add('hidden');
            });
        }
    }));



(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data("ordersGrid", ()=>({
        ready: false,
        sectionId: null,
        _orders: [],
        get orders () {
            const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
            const end = start + this.pagination.perPage;
            return this._orders// Filter orders based on the selected status (pending or complete)
            .filter((order)=>{
                if (this.status === "pending") return order.fulfillment_status !== "complete";
                return order.fulfillment_status === "complete";
            })// Sort the filtered orders based on the selected sorting field and direction
            .sort((a, b)=>{
                const field = this.sorting.field;
                const direction = this.sorting.direction === "asc" ? 1 : -1;
                const getValue = (obj, path)=>{
                    return path.split(".").reduce((acc, part)=>acc && acc[part], obj);
                };
                const aValue = getValue(a, field);
                const bValue = getValue(b, field);
                if (aValue < bValue) return -1 * direction;
                if (aValue > bValue) return 1 * direction;
                return 0;
            })// Return only the orders for the current page based on pagination settings
            .slice(start, end);
        },
        sorting: {
            field: "created_at.raw",
            direction: "desc"
        },
        pagination: {
            perPage: 20,
            currentPage: 1,
            totalPages: 1
        },
        status: "pending",
        init () {
            this.getOrders();
            // Keep pagination state valid when filters and sorting change.
            this.$watch("status", ()=>{
                this.pagination.currentPage = 1;
                this.recalculatePagination();
            });
            this.$watch("sorting.field", ()=>{
                this.pagination.currentPage = 1;
                this.recalculatePagination();
            });
            this.$watch("sorting.direction", ()=>{
                this.pagination.currentPage = 1;
                this.recalculatePagination();
            });
        },
        recalculatePagination () {
            this.pagination.totalPages = Math.max(1, Math.ceil(this._orders.filter((order)=>{
                if (this.status === "pending") return order.fulfillment_status !== "complete";
                return order.fulfillment_status === "complete";
            }).length / this.pagination.perPage));
            this.pagination.currentPage = Math.min(this.pagination.currentPage, this.pagination.totalPages);
        },
        setSorting (field, direction) {
            this.sorting.field = field;
            this.sorting.direction = direction;
        },
        isSortedBy (field, direction) {
            return this.sorting.field === field && this.sorting.direction === direction;
        },
        getOrders () {
            this.ready = false;
            this._orders = [];
            this.pagination.currentPage = 1;
            this.pagination.totalPages = 1;
            const getPage = (pageNumber = 1, pageParam = "page")=>{
                const url = new URL(window.location.origin);
                if (!this.sectionId) this.sectionId = document.querySelector(".shopify-section[id*='orders-js']").id.replace("shopify-section-", "");
                url.searchParams.set("sections", this.sectionId);
                url.searchParams.set(pageParam, pageNumber);
                return fetch(url.toString()).then((response)=>response.json()).then((sections)=>{
                    const html = sections[this.sectionId];
                    if (!html) return;
                    const parser = new DOMParser();
                    const dataScript = parser.parseFromString(html, "text/html").querySelector('script[type="application/json"]');
                    if (!dataScript) return;
                    const payload = JSON.parse(dataScript.textContent || "{}");
                    const pageOrders = Array.isArray(payload.data) ? payload.data : [];
                    this._orders = [
                        ...this._orders,
                        ...pageOrders
                    ];
                    const pagination = payload.pagination;
                    if (!pagination) return;
                    const currentPage = Number(pagination.current_page) || pageNumber;
                    const totalPages = Number(pagination.total_pages) || currentPage;
                    const nextPageParam = pagination.page_param || pageParam;
                    if (currentPage < totalPages) return getPage(currentPage + 1, nextPageParam);
                });
            };
            getPage().then(()=>{
                this.recalculatePagination();
                if (this._orders.length === 0) console.log("No orders found.");
            }).catch((error)=>{
                console.error("Failed to fetch orders.", error);
            }).finally(()=>{
                this.ready = true;
            });
        },
        productAvailabilityMap: [],
        productAvailabilityRequests: [],
        getReorderLink (order) {
            const url = new URL(window.location.origin);
            const availableItems = order.line_items.filter((item)=>{
                // do a quick HEAD check for a 404
                const availability = this.productAvailabilityMap.find((product)=>product.id === item.variant.id);
                if (!availability) {
                    const requestInFlight = this.productAvailabilityRequests.includes(item.variant.id);
                    if (!requestInFlight) {
                        this.productAvailabilityRequests.push(item.variant.id);
                        fetch(item.variant.url, {
                            method: "HEAD"
                        }).then((response)=>{
                            this.productAvailabilityMap.push({
                                id: item.variant.id,
                                available: response.ok
                            });
                        }).catch((error)=>{
                            console.error(`Failed to check availability for product ${item.variant.id}.`, error);
                        }).finally(()=>{
                            this.productAvailabilityRequests = this.productAvailabilityRequests.filter((id)=>id !== item.variant.id);
                        });
                    }
                    return true;
                }
                return availability.available;
            });
            if (availableItems.length === 0) return null;
            url.pathname = "/cart/" + availableItems.map((item)=>`${item.variant.id}:${item.quantity}`).join(",");
            return url.toString();
        }
    }));





// node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var $ded98599682c9305$var$min = Math.min;
var $ded98599682c9305$var$max = Math.max;
var $ded98599682c9305$var$round = Math.round;
var $ded98599682c9305$var$floor = Math.floor;
var $ded98599682c9305$var$createCoords = (v)=>({
        x: v,
        y: v
    });
var $ded98599682c9305$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var $ded98599682c9305$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $ded98599682c9305$var$clamp(start, value, end) {
    return $ded98599682c9305$var$max(start, $ded98599682c9305$var$min(value, end));
}
function $ded98599682c9305$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $ded98599682c9305$var$getSide(placement) {
    return placement.split("-")[0];
}
function $ded98599682c9305$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $ded98599682c9305$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $ded98599682c9305$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $ded98599682c9305$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($ded98599682c9305$var$getSide(placement)) ? "y" : "x";
}
function $ded98599682c9305$var$getAlignmentAxis(placement) {
    return $ded98599682c9305$var$getOppositeAxis($ded98599682c9305$var$getSideAxis(placement));
}
function $ded98599682c9305$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $ded98599682c9305$var$getAlignment(placement);
    const alignmentAxis = $ded98599682c9305$var$getAlignmentAxis(placement);
    const length = $ded98599682c9305$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $ded98599682c9305$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $ded98599682c9305$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $ded98599682c9305$var$getExpandedPlacements(placement) {
    const oppositePlacement = $ded98599682c9305$var$getOppositePlacement(placement);
    return [
        $ded98599682c9305$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $ded98599682c9305$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $ded98599682c9305$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$ded98599682c9305$var$oppositeAlignmentMap[alignment]);
}
function $ded98599682c9305$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $ded98599682c9305$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $ded98599682c9305$var$getAlignment(placement);
    let list = $ded98599682c9305$var$getSideList($ded98599682c9305$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($ded98599682c9305$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $ded98599682c9305$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$ded98599682c9305$var$oppositeSideMap[side]);
}
function $ded98599682c9305$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $ded98599682c9305$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $ded98599682c9305$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $ded98599682c9305$var$rectToClientRect(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
// node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function $ded98599682c9305$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $ded98599682c9305$var$getSideAxis(placement);
    const alignmentAxis = $ded98599682c9305$var$getAlignmentAxis(placement);
    const alignLength = $ded98599682c9305$var$getAxisLength(alignmentAxis);
    const side = $ded98599682c9305$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($ded98599682c9305$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
var $ded98599682c9305$var$computePosition = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform2 } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
    let rects = await platform2.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $ded98599682c9305$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform2,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform2.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $ded98599682c9305$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
async function $ded98599682c9305$var$detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform2, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $ded98599682c9305$var$evaluate(options, state);
    const paddingObject = $ded98599682c9305$var$getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $ded98599682c9305$var$rectToClientRect(await platform2.getClippingRect({
        element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
    const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $ded98599682c9305$var$rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
var $ded98599682c9305$var$flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform2, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = $ded98599682c9305$var$evaluate(options, state);
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = $ded98599682c9305$var$getSide(placement);
            const isBasePlacement = $ded98599682c9305$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $ded98599682c9305$var$getOppositePlacement(initialPlacement)
            ] : $ded98599682c9305$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$ded98599682c9305$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements2 = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $ded98599682c9305$var$detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides2 = $ded98599682c9305$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            if (!overflows.every((side2)=>side2 <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements2[nextIndex];
                if (nextPlacement) return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement2 = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow2)=>overflow2 > 0).reduce((acc, overflow2)=>acc + overflow2, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement2) resetPlacement = placement2;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
async function $ded98599682c9305$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform2, elements: elements } = state;
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
    const side = $ded98599682c9305$var$getSide(placement);
    const alignment = $ded98599682c9305$var$getAlignment(placement);
    const isVertical = $ded98599682c9305$var$getSideAxis(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = $ded98599682c9305$var$evaluate(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
var $ded98599682c9305$var$offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $ded98599682c9305$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
var $ded98599682c9305$var$shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x2, y: y2 } = _ref;
                    return {
                        x: x2,
                        y: y2
                    };
                }
            }, ...detectOverflowOptions } = $ded98599682c9305$var$evaluate(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $ded98599682c9305$var$detectOverflow(state, detectOverflowOptions);
            const crossAxis = $ded98599682c9305$var$getSideAxis($ded98599682c9305$var$getSide(placement));
            const mainAxis = $ded98599682c9305$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min2 = mainAxisCoord + overflow[minSide];
                const max2 = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $ded98599682c9305$var$clamp(min2, mainAxisCoord, max2);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min2 = crossAxisCoord + overflow[minSide];
                const max2 = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $ded98599682c9305$var$clamp(min2, crossAxisCoord, max2);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
// node_modules/@floating-ui/utils/dom/dist/floating-ui.utils.dom.mjs
function $ded98599682c9305$var$getNodeName(node) {
    if ($ded98599682c9305$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function $ded98599682c9305$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $ded98599682c9305$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($ded98599682c9305$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $ded98599682c9305$var$isNode(value) {
    return value instanceof Node || value instanceof $ded98599682c9305$var$getWindow(value).Node;
}
function $ded98599682c9305$var$isElement(value) {
    return value instanceof Element || value instanceof $ded98599682c9305$var$getWindow(value).Element;
}
function $ded98599682c9305$var$isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof $ded98599682c9305$var$getWindow(value).HTMLElement;
}
function $ded98599682c9305$var$isShadowRoot(value) {
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $ded98599682c9305$var$getWindow(value).ShadowRoot;
}
function $ded98599682c9305$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $ded98599682c9305$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $ded98599682c9305$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($ded98599682c9305$var$getNodeName(element));
}
function $ded98599682c9305$var$isContainingBlock(element) {
    const webkit = $ded98599682c9305$var$isWebKit();
    const css = $ded98599682c9305$var$getComputedStyle(element);
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $ded98599682c9305$var$getContainingBlock(element) {
    let currentNode = $ded98599682c9305$var$getParentNode(element);
    while($ded98599682c9305$var$isHTMLElement(currentNode) && !$ded98599682c9305$var$isLastTraversableNode(currentNode)){
        if ($ded98599682c9305$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $ded98599682c9305$var$getParentNode(currentNode);
    }
    return null;
}
function $ded98599682c9305$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $ded98599682c9305$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ded98599682c9305$var$getNodeName(node));
}
function $ded98599682c9305$var$getComputedStyle(element) {
    return $ded98599682c9305$var$getWindow(element).getComputedStyle(element);
}
function $ded98599682c9305$var$getNodeScroll(element) {
    if ($ded98599682c9305$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $ded98599682c9305$var$getParentNode(node) {
    if ($ded98599682c9305$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $ded98599682c9305$var$isShadowRoot(node) && node.host || // Fallback.
    $ded98599682c9305$var$getDocumentElement(node);
    return $ded98599682c9305$var$isShadowRoot(result) ? result.host : result;
}
function $ded98599682c9305$var$getNearestOverflowAncestor(node) {
    const parentNode = $ded98599682c9305$var$getParentNode(node);
    if ($ded98599682c9305$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($ded98599682c9305$var$isHTMLElement(parentNode) && $ded98599682c9305$var$isOverflowElement(parentNode)) return parentNode;
    return $ded98599682c9305$var$getNearestOverflowAncestor(parentNode);
}
function $ded98599682c9305$var$getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $ded98599682c9305$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $ded98599682c9305$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $ded98599682c9305$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $ded98599682c9305$var$getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, $ded98599682c9305$var$getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
// node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function $ded98599682c9305$var$getCssDimensions(element) {
    const css = $ded98599682c9305$var$getComputedStyle(element);
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $ded98599682c9305$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $ded98599682c9305$var$round(width) !== offsetWidth || $ded98599682c9305$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $ded98599682c9305$var$unwrapElement(element) {
    return !$ded98599682c9305$var$isElement(element) ? element.contextElement : element;
}
function $ded98599682c9305$var$getScale(element) {
    const domElement = $ded98599682c9305$var$unwrapElement(element);
    if (!$ded98599682c9305$var$isHTMLElement(domElement)) return $ded98599682c9305$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $ded98599682c9305$var$getCssDimensions(domElement);
    let x = ($ ? $ded98599682c9305$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $ded98599682c9305$var$round(rect.height) : rect.height) / height;
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $ded98599682c9305$var$noOffsets = /* @__PURE__ */ $ded98599682c9305$var$createCoords(0);
function $ded98599682c9305$var$getVisualOffsets(element) {
    const win = $ded98599682c9305$var$getWindow(element);
    if (!$ded98599682c9305$var$isWebKit() || !win.visualViewport) return $ded98599682c9305$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $ded98599682c9305$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $ded98599682c9305$var$getWindow(element)) return false;
    return isFixed;
}
function $ded98599682c9305$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ded98599682c9305$var$unwrapElement(element);
    let scale = $ded98599682c9305$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($ded98599682c9305$var$isElement(offsetParent)) scale = $ded98599682c9305$var$getScale(offsetParent);
        } else scale = $ded98599682c9305$var$getScale(element);
    }
    const visualOffsets = $ded98599682c9305$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $ded98599682c9305$var$getVisualOffsets(domElement) : $ded98599682c9305$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $ded98599682c9305$var$getWindow(domElement);
        const offsetWin = offsetParent && $ded98599682c9305$var$isElement(offsetParent) ? $ded98599682c9305$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $ded98599682c9305$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $ded98599682c9305$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = $ded98599682c9305$var$getWindow(currentIFrame).frameElement;
        }
    }
    return $ded98599682c9305$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $ded98599682c9305$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $ded98599682c9305$var$isHTMLElement(offsetParent);
    const documentElement = $ded98599682c9305$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $ded98599682c9305$var$createCoords(1);
    const offsets = $ded98599682c9305$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($ded98599682c9305$var$getNodeName(offsetParent) !== "body" || $ded98599682c9305$var$isOverflowElement(documentElement)) scroll = $ded98599682c9305$var$getNodeScroll(offsetParent);
        if ($ded98599682c9305$var$isHTMLElement(offsetParent)) {
            const offsetRect = $ded98599682c9305$var$getBoundingClientRect(offsetParent);
            scale = $ded98599682c9305$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $ded98599682c9305$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $ded98599682c9305$var$getWindowScrollBarX(element) {
    return $ded98599682c9305$var$getBoundingClientRect($ded98599682c9305$var$getDocumentElement(element)).left + $ded98599682c9305$var$getNodeScroll(element).scrollLeft;
}
function $ded98599682c9305$var$getDocumentRect(element) {
    const html = $ded98599682c9305$var$getDocumentElement(element);
    const scroll = $ded98599682c9305$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $ded98599682c9305$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $ded98599682c9305$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $ded98599682c9305$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($ded98599682c9305$var$getComputedStyle(body).direction === "rtl") x += $ded98599682c9305$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ded98599682c9305$var$getViewportRect(element, strategy) {
    const win = $ded98599682c9305$var$getWindow(element);
    const html = $ded98599682c9305$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $ded98599682c9305$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ded98599682c9305$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ded98599682c9305$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $ded98599682c9305$var$isHTMLElement(element) ? $ded98599682c9305$var$getScale(element) : $ded98599682c9305$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ded98599682c9305$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $ded98599682c9305$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $ded98599682c9305$var$getDocumentRect($ded98599682c9305$var$getDocumentElement(element));
    else if ($ded98599682c9305$var$isElement(clippingAncestor)) rect = $ded98599682c9305$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $ded98599682c9305$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return $ded98599682c9305$var$rectToClientRect(rect);
}
function $ded98599682c9305$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $ded98599682c9305$var$getParentNode(element);
    if (parentNode === stopNode || !$ded98599682c9305$var$isElement(parentNode) || $ded98599682c9305$var$isLastTraversableNode(parentNode)) return false;
    return $ded98599682c9305$var$getComputedStyle(parentNode).position === "fixed" || $ded98599682c9305$var$hasFixedPositionAncestor(parentNode, stopNode);
}
function $ded98599682c9305$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $ded98599682c9305$var$getOverflowAncestors(element, [], false).filter((el)=>$ded98599682c9305$var$isElement(el) && $ded98599682c9305$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $ded98599682c9305$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $ded98599682c9305$var$getParentNode(element) : element;
    while($ded98599682c9305$var$isElement(currentNode) && !$ded98599682c9305$var$isLastTraversableNode(currentNode)){
        const computedStyle = $ded98599682c9305$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $ded98599682c9305$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $ded98599682c9305$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $ded98599682c9305$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = $ded98599682c9305$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
function $ded98599682c9305$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $ded98599682c9305$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $ded98599682c9305$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $ded98599682c9305$var$max(rect.top, accRect.top);
        accRect.right = $ded98599682c9305$var$min(rect.right, accRect.right);
        accRect.bottom = $ded98599682c9305$var$min(rect.bottom, accRect.bottom);
        accRect.left = $ded98599682c9305$var$max(rect.left, accRect.left);
        return accRect;
    }, $ded98599682c9305$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $ded98599682c9305$var$getDimensions(element) {
    return $ded98599682c9305$var$getCssDimensions(element);
}
function $ded98599682c9305$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $ded98599682c9305$var$isHTMLElement(offsetParent);
    const documentElement = $ded98599682c9305$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $ded98599682c9305$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $ded98599682c9305$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($ded98599682c9305$var$getNodeName(offsetParent) !== "body" || $ded98599682c9305$var$isOverflowElement(documentElement)) scroll = $ded98599682c9305$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ded98599682c9305$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $ded98599682c9305$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $ded98599682c9305$var$getTrueOffsetParent(element, polyfill) {
    if (!$ded98599682c9305$var$isHTMLElement(element) || $ded98599682c9305$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $ded98599682c9305$var$getOffsetParent(element, polyfill) {
    const window2 = $ded98599682c9305$var$getWindow(element);
    if (!$ded98599682c9305$var$isHTMLElement(element)) return window2;
    let offsetParent = $ded98599682c9305$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $ded98599682c9305$var$isTableElement(offsetParent) && $ded98599682c9305$var$getComputedStyle(offsetParent).position === "static")offsetParent = $ded98599682c9305$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($ded98599682c9305$var$getNodeName(offsetParent) === "html" || $ded98599682c9305$var$getNodeName(offsetParent) === "body" && $ded98599682c9305$var$getComputedStyle(offsetParent).position === "static" && !$ded98599682c9305$var$isContainingBlock(offsetParent))) return window2;
    return offsetParent || $ded98599682c9305$var$getContainingBlock(element) || window2;
}
var $ded98599682c9305$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $ded98599682c9305$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $ded98599682c9305$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $ded98599682c9305$var$isRTL(element) {
    return $ded98599682c9305$var$getComputedStyle(element).direction === "rtl";
}
var $ded98599682c9305$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $ded98599682c9305$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $ded98599682c9305$var$getDocumentElement,
    getClippingRect: $ded98599682c9305$var$getClippingRect,
    getOffsetParent: $ded98599682c9305$var$getOffsetParent,
    getElementRects: $ded98599682c9305$var$getElementRects,
    getClientRects: $ded98599682c9305$var$getClientRects,
    getDimensions: $ded98599682c9305$var$getDimensions,
    getScale: $ded98599682c9305$var$getScale,
    isElement: $ded98599682c9305$var$isElement,
    isRTL: $ded98599682c9305$var$isRTL
};
function $ded98599682c9305$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $ded98599682c9305$var$getDocumentElement(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $ded98599682c9305$var$floor(top);
        const insetRight = $ded98599682c9305$var$floor(root.clientWidth - (left + width));
        const insetBottom = $ded98599682c9305$var$floor(root.clientHeight - (top + height));
        const insetLeft = $ded98599682c9305$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $ded98599682c9305$var$max(0, $ded98599682c9305$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
function $ded98599682c9305$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $ded98599682c9305$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $ded98599682c9305$var$getOverflowAncestors(referenceEl) : [],
        ...$ded98599682c9305$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $ded98599682c9305$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ded98599682c9305$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ded98599682c9305$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
var $ded98599682c9305$var$computePosition2 = (reference, floating, options)=>{
    const cache = /* @__PURE__ */ new Map();
    const mergedOptions = {
        platform: $ded98599682c9305$var$platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return $ded98599682c9305$var$computePosition(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
// packages/anchor/src/index.js
function $ded98599682c9305$export$2e2992790a6f69a8(Alpine) {
    Alpine.magic("anchor", (el)=>{
        if (!el._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
        return el._x_anchor;
    });
    Alpine.interceptClone((from, to)=>{
        if (from && from._x_anchor && !to._x_anchor) to._x_anchor = from._x_anchor;
    });
    Alpine.directive("anchor", Alpine.skipDuringClone((el, { expression: expression, modifiers: modifiers, value: value }, { cleanup: cleanup, evaluate: evaluate2 })=>{
        let { placement: placement, offsetValue: offsetValue, unstyled: unstyled } = $ded98599682c9305$var$getOptions(modifiers);
        el._x_anchor = Alpine.reactive({
            x: 0,
            y: 0
        });
        let reference = evaluate2(expression);
        if (!reference) throw "Alpine: no element provided to x-anchor...";
        let compute = ()=>{
            let previousValue;
            $ded98599682c9305$var$computePosition2(reference, el, {
                placement: placement,
                middleware: [
                    $ded98599682c9305$var$flip(),
                    $ded98599682c9305$var$shift({
                        padding: 5
                    }),
                    $ded98599682c9305$var$offset(offsetValue)
                ]
            }).then(({ x: x, y: y })=>{
                unstyled || $ded98599682c9305$var$setStyles(el, x, y);
                if (JSON.stringify({
                    x: x,
                    y: y
                }) !== previousValue) {
                    el._x_anchor.x = x;
                    el._x_anchor.y = y;
                }
                previousValue = JSON.stringify({
                    x: x,
                    y: y
                });
            });
        };
        let release = $ded98599682c9305$var$autoUpdate(reference, el, ()=>compute());
        cleanup(()=>release());
    }, // When cloning (or "morphing"), we will graft the style and position data from the live tree...
    (el, { expression: expression, modifiers: modifiers, value: value }, { cleanup: cleanup, evaluate: evaluate2 })=>{
        let { placement: placement, offsetValue: offsetValue, unstyled: unstyled } = $ded98599682c9305$var$getOptions(modifiers);
        if (el._x_anchor) unstyled || $ded98599682c9305$var$setStyles(el, el._x_anchor.x, el._x_anchor.y);
    }));
}
function $ded98599682c9305$var$setStyles(el, x, y) {
    Object.assign(el.style, {
        left: x + "px",
        top: y + "px",
        position: "absolute"
    });
}
function $ded98599682c9305$var$getOptions(modifiers) {
    let positions = [
        "top",
        "top-start",
        "top-end",
        "right",
        "right-start",
        "right-end",
        "bottom",
        "bottom-start",
        "bottom-end",
        "left",
        "left-start",
        "left-end"
    ];
    let placement = positions.find((i)=>modifiers.includes(i));
    let offsetValue = 0;
    if (modifiers.includes("offset")) {
        let idx = modifiers.findIndex((i)=>i === "offset");
        offsetValue = modifiers[idx + 1] !== void 0 ? Number(modifiers[idx + 1]) : offsetValue;
    }
    let unstyled = modifiers.includes("no-style");
    return {
        placement: placement,
        offsetValue: offsetValue,
        unstyled: unstyled
    };
}
// packages/anchor/builds/module.js
var $ded98599682c9305$export$2e2bcd8739ae039 = $ded98599682c9305$export$2e2992790a6f69a8;


// packages/collapse/src/index.js
function $0da0a17d2b53e69a$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $0da0a17d2b53e69a$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $0da0a17d2b53e69a$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $0da0a17d2b53e69a$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $0da0a17d2b53e69a$export$2e2bcd8739ae039 = $0da0a17d2b53e69a$export$ec45920981e0ca9b;


// packages/persist/src/index.js
function $83bfdc0c6067767d$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $83bfdc0c6067767d$var$storageHas(lookup, storage) ? $83bfdc0c6067767d$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $83bfdc0c6067767d$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $83bfdc0c6067767d$var$storageHas(key, storage) ? $83bfdc0c6067767d$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $83bfdc0c6067767d$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $83bfdc0c6067767d$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $83bfdc0c6067767d$var$storageGet(key, storage) {
    let value = storage.getItem(key);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $83bfdc0c6067767d$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $83bfdc0c6067767d$export$2e2bcd8739ae039 = $83bfdc0c6067767d$export$9a6132153fba2e0;


// packages/intersect/src/index.js
function $88fc130f586896c1$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $88fc130f586896c1$var$getRootMargin(modifiers),
            threshold: $88fc130f586896c1$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $88fc130f586896c1$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $88fc130f586896c1$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $88fc130f586896c1$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($88fc130f586896c1$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $88fc130f586896c1$export$2e2bcd8739ae039 = $88fc130f586896c1$export$1f4807a235930d45;



var $jjFgX = parcelRequire("jjFgX");
let $392419b76251c10f$var$onCopy = ()=>{};
const $392419b76251c10f$var$copy = (target, mimeType)=>{
    if (typeof target === 'function') target = target();
    if (typeof target === 'object') target = JSON.stringify(target);
    if (mimeType !== undefined) return window.navigator.clipboard.write([
        new ClipboardItem({
            [mimeType]: new Blob([
                target
            ], {
                type: mimeType
            })
        })
    ]).then($392419b76251c10f$var$onCopy);
    return window.navigator.clipboard.writeText(target).then($392419b76251c10f$var$onCopy);
};
function $392419b76251c10f$var$Clipboard(Alpine) {
    Alpine.magic('clipboard', ()=>{
        return $392419b76251c10f$var$copy;
    });
    Alpine.directive('clipboard', (el, { modifiers: modifiers, expression: expression }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        const getCopyContent = modifiers.includes('raw') ? (c)=>c(expression) : evaluateLater(expression);
        const clickHandler = ()=>getCopyContent($392419b76251c10f$var$copy);
        el.addEventListener('click', clickHandler);
        cleanup(()=>{
            el.removeEventListener('click', clickHandler);
        });
    });
}
$392419b76251c10f$var$Clipboard.configure = (config)=>{
    if (config.hasOwnProperty('onCopy') && typeof config.onCopy === 'function') $392419b76251c10f$var$onCopy = config.onCopy;
    return $392419b76251c10f$var$Clipboard;
};
var $392419b76251c10f$export$2e2bcd8739ae039 = $392419b76251c10f$var$Clipboard;


/**
 * Dialog Close on Backdrop Click
 */ document.addEventListener("click", (event)=>{
    if (event.target.tagName === "DIALOG") event.target.close();
});
window.Fuse = (0, $aef5620a7182edcc$export$2e2bcd8739ae039);
window.Alpine = (0, $99b18dd98d1424fc$export$2e2bcd8739ae039);
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $ded98599682c9305$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $0da0a17d2b53e69a$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $83bfdc0c6067767d$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $88fc130f586896c1$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $jjFgX.default));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).plugin((0, $392419b76251c10f$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).start();
/**
 * Dispatch Base Ready Event
 */ window.dispatchEvent(new CustomEvent("base:ready"));

})();
//# sourceMappingURL=main.js.map
